/**
 * 미감정 아이템 이름 표 — **자동 생성 파일. 직접 고치지 말 것.**
 *
 * 서버는 미감정 아이템의 표시명으로 `$3288` 같은 원본 클라이언트 리소스 키를
 * 보낸다(weapons/armors/etc_items의 unidentified_name_id). 그 키의 실제 문장
 * ("낡은 검" 같은 외형 묘사)은 원본 클라이언트 안에만 있어 서버에도 없다.
 *
 * 묘사를 복원할 수 없으므로 **아이템 종류**로 대신 보여준다. 미감정 상태에서
 * 종류만 드러나는 것은 원작 동작과도 어긋나지 않는다.
 *
 * 예외로, 미감정 이름과 감정 이름이 같은 키(아데나·열쇠·배표처럼 감정 개념이
 * 없는 아이템)는 감출 것이 없으므로 DB의 실제 이름을 그대로 쓴다. 그 키를 쓰는
 * 이름이 유일할 때만 해당한다.
 *
 * 재생성: python3 scripts/gen_item_names.py > web-client/src/data/unidentifiedItemNames.ts
 */
export const UNIDENTIFIED_ITEM_NAMES: Record<string, string> = {
  '$1958 $1938': '양손검',
  '$1958 $1939': '검',
  '$0': '장검',
  '$2458 $2449': '쌍검',
  '$2459 $2449': '쌍검',
  '$2460 $2449': '쌍검',
  '$656 $2449': '쌍검',
  '$2452 $2449': '쌍검',
  '$2461 $2449': '쌍검',
  '$2462 $2449': '쌍검',
  '$2453 $2449': '쌍검',
  '$2458 $372': '클로',
  '$2459 $372': '클로',
  '$2460 $372': '클로',
  '$656 $372': '클로',
  '$2452 $372': '클로',
  '$2461 $372': '클로',
  '$2462 $372': '클로',
  '$2453 $372': '클로',
  '$1958 $1940': '활',
  '$2452 $784': '활',
  '$2453 $784': '활',
  '$10236$2449': '쌍검',
  '$10236$2450': '클로',
  '$2452 $2468': '투구',
  '$2452 $225': '망토',
  '$656 $225': '망토',
  '$2452 $2466': '갑옷',
  '$2571 $152': '갑옷',
  '$2452 $330': '장갑',
  '$2452 $207': '부츠',
  '$1667 $1007': '목걸이',
  '$1667 $1003': '목걸이',
  '$1667 $1002': '목걸이',
  '$1667 $1005': '목걸이',
  '$1667 $1006': '목걸이',
  '$1667 $1004': '목걸이',
  '$1667 $1669': '벨트',
  '$1667 $1671': '벨트',
  '$1667 $1670': '벨트',
  '$1000 의상': '귀걸이',
  '$1783 의상': '귀걸이',
  '$1395 의상': '귀걸이',
  '$1652 $234': '물약',
  '$107 $2372': '물약',
  '$85 $2372': '물약',
  '$106 $2372': '물약',
  '$799 $512': '보석',
  '$799 $513': '보석',
  '$799 $514': '보석',
  '$799 $515': '보석',
  '$800 $512': '보석',
  '$800 $513': '보석',
  '$800 $514': '보석',
  '$800 $515': '보석',
  '$6 $23': '음식',
  '$1619 $1622': '음식',
  '$1622 $1181': '음식',
  '$1654 $1616': '폭죽',
  '$1655 $1616': '폭죽',
  '$799 $1655 $1616': '폭죽',
  '$1627 $1630 $1616': '폭죽',
  '$1627 $1656': '폭죽',
  '$1627 $1616': '폭죽',
  '$1627 $1631 $1616': '폭죽',
  '$1625 $1630 $1616': '폭죽',
  '$1625 $1656': '폭죽',
  '$1625 $1616': '폭죽',
  '$1625 $1631 $1616': '폭죽',
  '$1626 $1630 $1629 $1616': '폭죽',
  '$1626 $1630 $1616': '폭죽',
  '$1626 $1632 $1616': '폭죽',
  '$1626 $1656': '폭죽',
  '$1626 $1629 $1616': '폭죽',
  '$1626 $1616': '폭죽',
  '$1626 $1631 $1616': '폭죽',
  '$1628 $1630 $1629 $1616': '폭죽',
  '$1628 $1630 $1616': '폭죽',
  '$1628 $1632 $1616': '폭죽',
  '$1628 $1656': '폭죽',
  '$1628 $1629 $1616': '폭죽',
  '$1628 $1616': '폭죽',
  '$1628 $1631 $1616': '폭죽',
  '$951 $230': '주문서',
  '$1487 $1436': '마법 주문서',
  '$1487 $1437': '마법 주문서',
  '$1487 $1438': '마법 주문서',
  '$1487 $1439': '마법 주문서',
  '$1487 $1440': '마법 주문서',
  '$1487 $1966': '마법 주문서',
  '$1487 $1967': '마법 주문서',
  '$1487 $1977': '마법 주문서',
  '$1487 $1441': '마법 주문서',
  '$1487 $1442': '마법 주문서',
  '$1487 $1443': '마법 주문서',
  '$1487 $1444': '마법 주문서',
  '$1487 $1445': '마법 주문서',
  '$1487 $1978': '마법 주문서',
  '$1487 $1968': '마법 주문서',
  '$1487 $1969': '마법 주문서',
  '$1487 $1446': '마법 주문서',
  '$1487 $1447': '마법 주문서',
  '$1487 $1448': '마법 주문서',
  '$1487 $1449': '마법 주문서',
  '$1487 $1450': '마법 주문서',
  '$1487 $1970': '마법 주문서',
  '$1487 $1979': '마법 주문서',
  '$1487 $1451': '마법 주문서',
  '$1487 $1452': '마법 주문서',
  '$1487 $1453': '마법 주문서',
  '$1487 $1454': '마법 주문서',
  '$1487 $1455': '마법 주문서',
  '$1487 $1971': '마법 주문서',
  '$1487 $1980': '마법 주문서',
  '$1487 $1981': '마법 주문서',
  '$1487 $1456': '마법 주문서',
  '$1487 $1457': '마법 주문서',
  '$1487 $1458': '마법 주문서',
  '$1487 $1459': '마법 주문서',
  '$1487 $1460': '마법 주문서',
  '$1487 $1972': '마법 주문서',
  '$1487 $1982': '마법 주문서',
  '$1487 $1983': '마법 주문서',
  '$4928$4932': '음식',
  '$4928$5218': '음식',
  '$4928$4929': '음식',
  '$4928$5219': '음식',
  '$4928$4930': '음식',
  '$4928$4931': '음식',
  '$4928$5220': '음식',
  '$4928$5221': '음식',
  '$2172 여관홀 $230': '주문서',
  '$967 로우 풀 $230': '주문서',
  '$968 카오 틱 신전 $230': '주문서',
  '$2129 $1435 $230': '주문서',
  '$2172 $230': '주문서',
  '$1487 $1461': '마법 주문서',
  '$1487 $1462': '마법 주문서',
  '$1487 $1463': '마법 주문서',
  '$1487 $1464': '마법 주문서',
  '$1487 $1465': '마법 주문서',
  '$1487 $1973': '마법 주문서',
  '$1487 $1984': '마법 주문서',
  '$1487 $1985': '마법 주문서',
  '$1487 $1466': '마법 주문서',
  '$1487 $1467': '마법 주문서',
  '$1487 $1468': '마법 주문서',
  '$1487 $1469': '마법 주문서',
  '$1487 $1470': '마법 주문서',
  '$1487 $1976': '마법 주문서',
  '$1487 $1986': '마법 주문서',
  '$1487 $1987': '마법 주문서',
  '$1487 $1471': '마법 주문서',
  '$1487 $1472': '마법 주문서',
  '$1487 $1473': '마법 주문서',
  '$1487 $1474': '마법 주문서',
  '$1487 $1475': '마법 주문서',
  '$1487 $1974': '마법 주문서',
  '$1487 $1988': '마법 주문서',
  '$1487 $1989': '마법 주문서',
  '$1487 $1476': '마법 주문서',
  '$1487 $1477': '마법 주문서',
  '$1487 $1478': '마법 주문서',
  '$1487 $1479': '마법 주문서',
  '$1487 $1480': '마법 주문서',
  '$1487 $1975': '마법 주문서',
  '$1487 $1990': '마법 주문서',
  '$1487 $1991': '마법 주문서',
  '$1487 $1481': '마법 주문서',
  '$1487 $1482': '마법 주문서',
  '$1487 $1483': '마법 주문서',
  '$1487 $1484': '마법 주문서',
  '$1487 $1485': '마법 주문서',
  '$1487 $1992': '마법 주문서',
  '$1487 $1993': '마법 주문서',
  '$1487 $1994': '마법 주문서',
  '$263 $1436': '마법 완드',
  '$263 $1437': '마법 완드',
  '$263 $1438': '마법 완드',
  '$263 $1439': '마법 완드',
  '$263 $1440': '마법 완드',
  '$263 $1966': '마법 완드',
  '$263 $1967': '마법 완드',
  '$263 $1977': '마법 완드',
  '$263 $1441': '마법 완드',
  '$263 $1442': '마법 완드',
  '$263 $1443': '마법 완드',
  '$263 $1444': '마법 완드',
  '$263 $1445': '마법 완드',
  '$263 $1978': '마법 완드',
  '$263 $1968': '마법 완드',
  '$263 $1969': '마법 완드',
  '$263 $1446': '마법 완드',
  '$263 $1447': '마법 완드',
  '$263 $1448': '마법 완드',
  '$263 $1449': '마법 완드',
  '$263 $1450': '마법 완드',
  '$263 $1970': '마법 완드',
  '$263 $1979': '마법 완드',
  '$263 $1451': '마법 완드',
  '$263 $1452': '마법 완드',
  '$263 $1453': '마법 완드',
  '$263 $1454': '마법 완드',
  '$263 $1455': '마법 완드',
  '$263 $1971': '마법 완드',
  '$263 $1980': '마법 완드',
  '$263 $1981': '마법 완드',
  '$263 $1456': '마법 완드',
  '$263 $1457': '마법 완드',
  '$263 $1458': '마법 완드',
  '$263 $1459': '마법 완드',
  '$263 $1460': '마법 완드',
  '$263 $1972': '마법 완드',
  '$263 $1982': '마법 완드',
  '$263 $1983': '마법 완드',
  '$263 $1461': '마법 완드',
  '$263 $1462': '마법 완드',
  '$263 $1463': '마법 완드',
  '$263 $1464': '마법 완드',
  '$263 $1465': '마법 완드',
  '$263 $1973': '마법 완드',
  '$263 $1984': '마법 완드',
  '$263 $1985': '마법 완드',
  '$263 $1466': '마법 완드',
  '$263 $1467': '마법 완드',
  '$263 $1468': '마법 완드',
  '$263 $1469': '마법 완드',
  '$263 $1470': '마법 완드',
  '$263 $1976': '마법 완드',
  '$263 $1986': '마법 완드',
  '$263 $1987': '마법 완드',
  '$263 $1471': '마법 완드',
  '$263 $1472': '마법 완드',
  '$263 $1473': '마법 완드',
  '$263 $1474': '마법 완드',
  '$263 $1475': '마법 완드',
  '$263 $1974': '마법 완드',
  '$263 $1988': '마법 완드',
  '$263 $1989': '마법 완드',
  '$263 $1476': '마법 완드',
  '$263 $1477': '마법 완드',
  '$263 $1478': '마법 완드',
  '$263 $1479': '마법 완드',
  '$263 $1480': '마법 완드',
  '$263 $1975': '마법 완드',
  '$263 $1990': '마법 완드',
  '$263 $1991': '마법 완드',
  '$263 $1481': '마법 완드',
  '$263 $1482': '마법 완드',
  '$263 $1483': '마법 완드',
  '$263 $1484': '마법 완드',
  '$263 $1485': '마법 완드',
  '$263 $1992': '마법 완드',
  '$263 $1993': '마법 완드',
  '$263 $1994': '마법 완드',
  '$4928$5430': '음식',
  '$4928$5431': '음식',
  '$4928$5432': '음식',
  '$4928$5433': '음식',
  '$4928$5434': '음식',
  '$4928$5435': '음식',
  '$4928$5436': '음식',
  '$4928$5437': '음식',
  '$4928$6099': '음식',
  '$4928$6100': '음식',
  '$4928$6101': '음식',
  '$4928$6102': '음식',
  '$4928$6103': '음식',
  '$4928$6104': '음식',
  '$4928$6105': '음식',
  '$4928$6106': '음식',
  '$ 6081의 비밀 실험실 - $ 7597 이동 스크롤': '주문서',
  '$1958$7885': '재료',
  '$1958$7886': '재료',
  '$1958$7887': '재료',
  '$1958$7888': '재료',
  '$6595II': '물약',
  '$1': '도끼',
  '$2': '등잔',
  '$3': '양손검',
  '$4': '아데나',
  '$12': '요정족 단검',
  '$13': '오크족 단검',
  '$14': '아탐',
  '$16': '일본도',
  '$17': '싸울아비 장검',
  '$20': '철퇴',
  '$23': '고기',
  '$24': '활',
  '$25': '창',
  '$26': '체력 회복제',
  '$27': '완드',
  '$28': '완드',
  '$55': '확인 주문서',
  '$60': '전투 도끼',
  '$61': '화살',
  '$62': '바르디쉐',
  '$63': '빌귀사름',
  '$64': '요정족 활',
  '$65': '오크족 활',
  '$66': '넓은 검',
  '$67': '양초',
  '$68': '당근',
  '$69': '몽둥이',
  '$70': '단검',
  '$71': '벡드코빈',
  '$72': '달걀',
  '$73': '포챠드',
  '$74': '도리깨',
  '$75': '넓은 창',
  '$76': '귀사름',
  '$77': '미늘창',
  '$81': '기병창',
  '$82': '레몬',
  '$83': '루선해머',
  '$84': '모닝스타',
  '$85': '오렌지',
  '$86': '팬케익',
  '$87': '파르티잔',
  '$92': '언월도',
  '$93': '은 화살',
  '$94': '난쟁이족 도끼',
  '$95': '요정족 창',
  '$96': '오크족 창',
  '$97': '난쟁이족 검',
  '$98': '요정족 검',
  '$99': '오크족 검',
  '$100': '짧은 검',
  '$102': '삼지창',
  '$103': '유니콘뿔',
  '$105': '장궁',
  '$106': '사과',
  '$107': '바나나',
  '$110': '엘븐 와퍼',
  '$111': '워해머',
  '$116': '가죽 갑옷',
  '$118': '요정족 가죽 투구',
  '$120': '오크족 투구',
  '$122': '난쟁이족 철 투구',
  '$128': '투구',
  '$137': '화룡 비늘 갑옷',
  '$138': '풍룡 비늘 갑옷',
  '$141': '수룡 비늘 갑옷',
  '$142': '지룡 비늘 갑옷',
  '$145': '화룡 비늘',
  '$146': '풍룡 비늘',
  '$149': '수룡 비늘',
  '$150': '지룡 비늘',
  '$152': '판금 갑옷',
  '$153': '수정 갑옷',
  '$154': '청동 판금 갑옷',
  '$155': '미늘 갑옷',
  '$156': '띠 갑옷',
  '$159': '사슬 갑옷',
  '$160': '오크족 사슬 갑옷',
  '$162': '비늘 갑옷',
  '$163': '징박힌 가죽 갑옷',
  '$164': '고리 갑옷',
  '$165': '오크족 고리 갑옷',
  '$167': '가죽 재킷',
  '$168': '티셔츠',
  '$170': '요정족 망토',
  '$172': '오크족 망토',
  '$174': '난쟁이족 망토',
  '$176': '기름 망토',
  '$178': '보호 망토',
  '$180': '투명 망토',
  '$182': '마법 망토',
  '$184': '치환 망토',
  '$186': '작은 방패',
  '$187': '요정족 방패',
  '$189': '우럭하이 방패',
  '$192': '붉은 기사의 방패',
  '$193': '큰 방패',
  '$194': '난쟁이족 둥근 방패',
  '$196': '반사 방패',
  '$198': '가죽 장갑',
  '$206': '짧은 부츠',
  '$207': '부츠',
  '$230': '주문서',
  '$232': '물약',
  '$233': '해독제',
  '$234': '물약',
  '$235': '고급 체력 회복제',
  '$238': '강력 체력 회복제',
  '$239': '물약',
  '$241': '순간이동 조종 반지',
  '$243': '저주 풀기 주문서',
  '$244': '무기 마법 주문서',
  '$249': '갑옷 마법 주문서',
  '$254': '갑옷 파괴 주문서',
  '$257': '부활 주문서',
  '$261': '변신 조종 반지',
  '$263': '마법 완드',
  '$307': '금빛 열쇠',
  '$308': '은회색 열쇠',
  '$312': '붉은 기사의 망토',
  '$313': '붉은 기사의 검',
  '$314': '글루디오 영지행 배표',
  '$315': '말하는 섬행 배표',
  '$326': '랜턴',
  '$327': '랜턴용 기름',
  '$330': '장갑',
  '$412': '대형 도끼',
  '$413': '면류관',
  '$414': '기사의 면갑',
  '$415': '그라디우스',
  '$416': '악운의 단검',
  '$417': '둠 블레이드',
  '$418': '광전사의 도끼',
  '$419': '에바의 방패',
  '$428': '포르세의 검',
  '$429': '사각 방패',
  '$499': '아투바의 토템',
  '$500': '네루가의 토템',
  '$501': '간디의 토템',
  '$502': '로바의 토템',
  '$503': '두다-마라의 토템',
  '$505': '귀환 주문서',
  '$508': '마력의 돌',
  '$512': '다이아몬드',
  '$513': '루비',
  '$514': '사파이어',
  '$515': '에메랄드',
  '$516': '마법 방어 사슬 갑옷',
  '$517': '마법서 (힐)',
  '$518': '마법서 (라이트)',
  '$519': '마법서 (실드)',
  '$520': '마법서 (에너지 볼트)',
  '$521': '마법서 (텔레포트)',
  '$522': '마법서 (큐어 포이즌)',
  '$523': '마법서 (칠 터치)',
  '$524': '마법서 (커스 포이즌)',
  '$525': '마법서 (인챈트 웨폰)',
  '$526': '마법서 (디텍션)',
  '$527': '마법서 (라이트닝)',
  '$528': '마법서 (턴 언데드)',
  '$529': '마법서 (익스트라 힐)',
  '$530': '마법서 (커스 블라인드)',
  '$531': '마법서 (블레스드 아머)',
  '$532': '마법서 (파이어볼)',
  '$533': '마법서 (인챈트 덱스터리티)',
  '$534': '마법서 (웨폰 브레이크)',
  '$535': '마법서 (뱀파이어릭 터치)',
  '$536': '마법서 (슬로우)',
  '$537': '마법서 (커스: 패럴라이즈)',
  '$538': '마법서 (콜 라이트닝)',
  '$539': '마법서 (그레이터 힐)',
  '$540': '마법서 (테이밍 몬스터)',
  '$541': '마법서 (리무브 커스)',
  '$542': '마법서 (크리에이트 좀비)',
  '$543': '마법서 (인챈트 마이티)',
  '$544': '마법서 (헤이스트)',
  '$545': '마법서 (캔슬레이션)',
  '$546': '마법서 (이럽션)',
  '$547': '마법서 (힐 올)',
  '$548': '마법서 (아이스 랜스)',
  '$549': '마법서 (서먼 몬스터)',
  '$550': '마법서 (홀리 워크)',
  '$551': '마법서 (토네이도)',
  '$552': '마법서 (풀 힐)',
  '$553': '마법서 (파이어월)',
  '$554': '마법서 (블리자드)',
  '$555': '마법서 (인비지블리티)',
  '$556': '마법서 (리절렉션)',
  '$557': '마법서 (라이트닝 스톰)',
  '$558': '마법서 (포그 오브 슬리핑)',
  '$559': '마법서 (셰이프 체인지)',
  '$560': '마법서 (이뮨 투 함)',
  '$561': '마법서 (매스 텔레포트)',
  '$562': '마법서 (크리에이트 매지컬 웨폰)',
  '$563': '마법서 (미티어 스트라이크)',
  '$564': '마법서 (그레이트 리절렉션)',
  '$565': '마법서 (매스 슬로우)',
  '$566': '마법서 (디스인티그레이트)',
  '$569': '마법 방어 투구',
  '$570': '참나무 지팡이',
  '$571': '마법사의 지팡이',
  '$572': '마력의 지팡이',
  '$573': '힘의 지팡이',
  '$580': '무명 로브',
  '$595': '요정족 사슬 갑옷',
  '$598': '다마스커스 검',
  '$617': '빨간색 양말',
  '$618': '매스 텔레포트 주문서',
  '$656': '은괴',
  '$759': '작은 활',
  '$760': '판의 갈기털',
  '$761': '미스릴 원석',
  '$762': '정령의 돌',
  '$763': '엔트의 줄기',
  '$764': '버섯포자의 즙',
  '$765': '오우거의 눈물',
  '$766': '실',
  '$767': '미스릴',
  '$768': '페어리 더스트',
  '$769': '아라크네의 거미줄',
  '$770': '엔트의 껍질',
  '$771': '오리하루콘',
  '$772': '미스릴 실',
  '$773': '미스릴 화살',
  '$774': '아라크네의 허물',
  '$775': '활 골무',
  '$776': '페어리의 날개',
  '$777': '마법의 플룻',
  '$778': '나무 방패',
  '$779': '미스릴 판금',
  '$780': '오리하루콘 판금',
  '$781': '나무 갑옷',
  '$782': '요정족 흉갑',
  '$783': '판의 뿔',
  '$784': '크로스 보우',
  '$785': '단검신',
  '$786': '장검신',
  '$787': '오리하루콘 검신',
  '$788': '요정족 판금 갑옷',
  '$789': '레이피어',
  '$790': '엘름의 축복',
  '$791': '미스릴 도금 뿔',
  '$792': '오리하루콘 도금 뿔',
  '$793': '메일 브레이커',
  '$794': '엔트의 열매',
  '$795': '파워 글로브',
  '$797': '듀펠게넌의 목걸이',
  '$798': '우드 벡 재킷',
  '$801': '요정족 검',
  '$802': '민첩도 향상 요정족 검',
  '$803': '마력 향상 요정족 검',
  '$922': '은기사의 방패',
  '$938': '마법의 투구: 치유',
  '$939': '마법의 투구: 신속',
  '$940': '마법의 투구: 힘',
  '$943': '용기의 물약',
  '$944': '지혜의 물약',
  '$954': '여관 열쇠',
  '$971': '변신 주문서',
  '$975': '추방 막대',
  '$1002': '완력의 목걸이',
  '$1003': '민첩의 목걸이',
  '$1004': '체력의 목걸이',
  '$1005': '지식의 목걸이',
  '$1006': '지혜의 목걸이',
  '$1007': '매력의 목걸이',
  '$1008': '인프라비젼 투구',
  '$1011': '바실리스크 뿔',
  '$1012': '드레이크 발톱',
  '$1013': '오크 투사의 목걸이',
  '$1014': '네크로맨서의 수정구',
  '$1020': '드래곤 슬레이어',
  '$1021': '가죽 모자',
  '$1022': '징박은 가죽모자',
  '$1023': '가죽 투구',
  '$1024': '해골투구',
  '$1025': '가죽 샌달',
  '$1026': '징박은 가죽샌달',
  '$1027': '가죽 부츠',
  '$1028': '가죽 방패',
  '$1029': '징박은 가죽방패',
  '$1030': '골각 방패',
  '$1031': '가죽 조끼',
  '$1032': '벨트달린 가죽조끼',
  '$1033': '징박은 가죽조끼',
  '$1034': '중갑 가죽 조끼',
  '$1035': '뼈갑옷',
  '$1036': '동물가죽',
  '$1037': '철괴',
  '$1038': '벨트',
  '$1039': '고급피혁',
  '$1040': '뼈조각',
  '$1048': '대검',
  '$1063': '마나의 지팡이',
  '$1086': '펫 호루라기',
  '$1098': '생명력 향상 요정족 검',
  '$1099': '민첩도 향상 요정족 활',
  '$1100': '숫돌',
  '$1101': '지도:아덴 전역',
  '$1102': '지도:말하는 섬',
  '$1103': '지도:글루디오',
  '$1104': '지도:켄트 성',
  '$1105': '지도:오크 요새',
  '$1106': '지도:요정의 숲',
  '$1107': '지도:윈다우드',
  '$1108': '지도:은기사 마을',
  '$1109': '지도:용의 계곡',
  '$1147': '은장검',
  '$1148': '은검',
  '$1149': '은도끼',
  '$1173': '기타 아이템',
  '$1179': '사탕',
  '$1188': '지도:기란',
  '$1191': '허브',
  '$1197': '파란 옷감',
  '$1199': '붉은 옷감',
  '$1200': '하얀 옷감',
  '$1201': '강철괴',
  '$1203': '강철 원석',
  '$1205': '부적',
  '$1206': '마법사의 모자',
  '$1207': '마법사의 옷',
  '$1208': '강철 장갑',
  '$1209': '강철 면갑',
  '$1210': '강철 방패',
  '$1211': '강철 부츠',
  '$1212': '강철 판금 갑옷',
  '$1244': '사냥꾼 활',
  '$1247': '레이스 표',
  '$1251': '농축 체력 회복제',
  '$1252': '농축 고급 체력 회복제',
  '$1253': '농축 강력 체력 회복제',
  '$1379': '사이하의 반지',
  '$1387': '가구 제거 막대',
  '$1410': '기란 마을 귀환 주문서',
  '$1411': '노래하는 섬 귀환 주문서',
  '$1424': '숨겨진 계곡 귀환 주문서',
  '$1486': '빈 주문서 (레벨 1)',
  '$1507': '에바의 축복',
  '$1508': '인어의 비늘',
  '$1533': '지도:노래하는 섬',
  '$1534': '지도:숨겨진 계곡',
  '$1535': '지도:하이네',
  '$1553': '생명의 검',
  '$1581': '마법서 (아이스 대거)',
  '$1582': '마법서 (윈드 커터)',
  '$1583': '마법서 (파이어 애로우)',
  '$1584': '마법서 (스탈락)',
  '$1585': '마법서 (프로즌 클라우드)',
  '$1586': '마법서 (어스 재일)',
  '$1587': '마법서 (콘 오브 콜드)',
  '$1588': '마법서 (선 버스트)',
  '$1589': '마법서 (어스 퀘이크)',
  '$1590': '마법서 (파이어 스톰)',
  '$1607': '지도:화룡의 둥지',
  '$1608': '아시타지오의 재',
  '$1646': '진실의 목걸이',
  '$1647': '정열의 목걸이',
  '$1648': '행운의 목걸이',
  '$1649': '희망의 목걸이',
  '$1650': '기적의 목걸이',
  '$1651': '마법서 (그레이터 헤이스트)',
  '$1661': '항마의 반지',
  '$1662': '멸마의 반지',
  '$1663': '화령의 반지',
  '$1664': '수령의 반지',
  '$1665': '지령의 반지',
  '$1666': '풍령의 반지',
  '$1669': '신체의 벨트',
  '$1670': '정신의 벨트',
  '$1671': '영혼의 벨트',
  '$1689': '희망의 반지',
  '$1690': '행운의 반지',
  '$1691': '기적의 반지',
  '$1692': '정열의 반지',
  '$1693': '진실의 반지',
  '$1755': '붉은 열쇠',
  '$1756': '검은 열쇠',
  '$1757': '섬의 증표',
  '$1758': '계곡의 증표',
  '$1759': '기사의 견습용 갑옷',
  '$1760': '기사의 견습용 방패',
  '$1761': '기사의 견습용 투구',
  '$1762': '견습용 검',
  '$1763': '군주의 견습용 갑옷',
  '$1764': '군주의 견습용 방패',
  '$1765': '군주의 견습용 투구',
  '$1766': '요정의 견습용 활',
  '$1767': '마법사의 견습용 망토',
  '$1768': '마법사의 견습용 부츠',
  '$1769': '마법사의 견습용 모자',
  '$1770': '마법사의 견습용 지팡이',
  '$1798': '돌 장갑',
  '$1800': '수정 장갑',
  '$1801': '설인 장갑',
  '$1804': '수중 부츠',
  '$1805': '데몬의 장갑',
  '$1806': '데몬의 갑옷',
  '$1807': '데몬의 부츠',
  '$1808': '데몬의 투구',
  '$1809': '데스나이트의 장갑',
  '$1810': '데스나이트의 갑옷',
  '$1811': '데스나이트의 부츠',
  '$1812': '데스나이트의 투구',
  '$1818': '트롤의 벨트',
  '$1819': '오우거의 벨트',
  '$1820': '타이탄의 벨트',
  '$1821': '사이하의 활',
  '$1822': '정령옥',
  '$1829': '정령의 수정 (레지스트 매직)',
  '$1830': '정령의 수정 (바디 투 마인드)',
  '$1831': '정령의 수정 (텔레포트 투 마더)',
  '$1832': '정령의 수정 (클리어 마인드)',
  '$1833': '정령의 수정 (레지스트 엘리멘트)',
  '$1834': '정령의 수정 (리턴 투 네이처)',
  '$1835': '정령의 수정 (블러드 투 소울)',
  '$1836': '정령의 수정 (프로텍션 프롬 엘리멘트)',
  '$1837': '정령의 수정 (파이어 웨폰)',
  '$1838': '정령의 수정 (윈드 샷)',
  '$1839': '정령의 수정 (윈드 워크)',
  '$1840': '정령의 수정 (어스 스킨)',
  '$1841': '정령의 수정 (인탱글)',
  '$1842': '정령의 수정 (이레이즈 매직)',
  '$1843': '정령의 수정 (서먼 레서 엘리멘탈)',
  '$1844': '정령의 수정 (블레스 오브 파이어)',
  '$1845': '정령의 수정 (아이 오브 스톰)',
  '$1846': '정령의 수정 (어스 바인드)',
  '$1847': '정령의 수정 (네이쳐스 터치)',
  '$1848': '정령의 수정 (블레스 오브 어스)',
  '$1849': '정령의 수정 (에어리어 오브 사일런스)',
  '$1850': '정령의 수정 (서먼 그레이터 엘리멘탈)',
  '$1851': '정령의 수정 (버닝 웨폰)',
  '$1852': '정령의 수정 (네이쳐스 블레싱)',
  '$1854': '정령의 수정 (스톰 샷)',
  '$1855': '정령의 수정 (윈드 셰클)',
  '$1856': '정령의 수정 (아이언 스킨)',
  '$1857': '마법서 (홀리 웨폰)',
  '$1858': '마법서 (디크리즈 웨이트)',
  '$1859': '마법서 (위크 엘리멘탈)',
  '$1860': '마법서 (카운터 매직)',
  '$1861': '마법서 (메디테이션)',
  '$1862': '마법서 (마나 드레인)',
  '$1863': '마법서 (다크니스)',
  '$1864': '마법서 (위크니스)',
  '$1865': '마법서 (블레스 웨폰)',
  '$1866': '마법서 (버서커스)',
  '$1867': '마법서 (디지즈)',
  '$1868': '마법서 (라이프 스트림)',
  '$1869': '마법서 (사일런스)',
  '$1870': '마법서 (디케이 포션)',
  '$1871': '마법서 (카운터 디텍션)',
  '$1872': '마법서 (앱솔루트 배리어)',
  '$1873': '마법서 (어드밴스 스피릿)',
  '$1874': '마법서 (프리징 블리자드)',
  '$1889': '지도:오렌',
  '$1890': '그리폰의 깃털',
  '$1891': '바람의 눈물',
  '$1892': '빈 주문서 (레벨 2)',
  '$1893': '빈 주문서 (레벨 3)',
  '$1894': '빈 주문서 (레벨 4)',
  '$1895': '빈 주문서 (레벨 5)',
  '$1899': '요정의 견습용 갑옷',
  '$1900': '요정의 견습용 부츠',
  '$1901': '요정의 견습용 투구',
  '$1903': '민첩함의 투구',
  '$1904': '체력의 투구',
  '$1905': '낡은 거래 문서',
  '$1908': '수색문서',
  '$1911': '흑기사의 서약서',
  '$1912': '두다 마라 오크 마법서',
  '$1913': '네루가 오크 마법서',
  '$1914': '간디 오크 마법서',
  '$1915': '아투바 오크 마법서',
  '$1916': '저주받은 마법서',
  '$1917': '마력서',
  '$1918': '붉은 망토',
  '$1919': '퀘스트 아이템',
  '$1920': '구울의 손톱',
  '$1921': '구울의 이빨',
  '$1922': '터틀 드래곤의 껍질',
  '$1923': '기사의 두건',
  '$1924': '붉은 기사의 두건',
  '$1930': '잊혀진 섬행 배표',
  '$1933': '잊혀진 판금 갑옷',
  '$1934': '잊혀진 가죽 갑옷',
  '$1935': '잊혀진 로브',
  '$1936': '잊혀진 비늘 갑옷',
  '$1937': '소환 조종 반지',
  '$1941': '낡은 바람의 투구',
  '$1942': '바람의 투구',
  '$1943': '토끼의 간',
  '$1945': '하이네행 배표',
  '$1946': '고대의 판금 갑옷',
  '$1947': '고대의 가죽 갑옷',
  '$1948': '고대의 로브',
  '$1949': '고대의 비늘 갑옷',
  '$1950': '고대의 검',
  '$1951': '고대의 대검',
  '$1952': '고대의 보우건',
  '$1957': '고대의 주문서',
  '$1959': '마법서 (트루 타겟)',
  '$1960': '마법서 (글로잉 오라)',
  '$1961': '생명의 비밀',
  '$1997': '환상의 검',
  '$1998': '환상의 갑옷',
  '$1999': '환상의 활',
  '$2000': '환상의 무기 마법 주문서',
  '$2001': '환상의 갑옷 마법 주문서',
  '$2003': '강철 마나의 지팡이',
  '$2022': '비밀방 열쇠',
  '$2023': '웅골리언트의 발톱',
  '$2024': '라미아의 비늘',
  '$2025': '환생의 물약',
  '$2026': '감사의 편지',
  '$2027': '마을 주민들의 유품',
  '$2029': '저주받은 정령서',
  '$2030': '언데드의 열쇠',
  '$2031': '좀비 열쇠',
  '$2032': '해골 열쇠',
  '$2033': '언데드의 뼈',
  '$2034': '언데드의 뼈조각',
  '$2065': '호박씨',
  '$2066': '거대 호박씨',
  '$2067': '호박 가면',
  '$2068': '호박 캔디',
  '$2069': '금호박',
  '$2070': '은호박',
  '$2071': '동호박',
  '$2072': '호박 투구',
  '$2075': '요정족 티셔츠',
  '$2076': '군주의 위엄',
  '$2078': '신비한 수정구',
  '$2079': '신비한 지팡이',
  '$2080': '수정 지팡이',
  '$2088': '라미아 방 열쇠',
  '$2089': '마법서 (콜 클렌)',
  '$2090': '아리아의 보답',
  '$2091': '요정족 보물',
  '$2094': '파푸리온의 마갑주',
  '$2095': '안타라스의 마갑주',
  '$2096': '발라카스의 마갑주',
  '$2097': '린드비오르의 마갑주',
  '$2168': '오만의 탑 21층 이동주문서',
  '$2169': '오만의 탑 11층 이동주문서',
  '$2189': '반왕의 갑옷',
  '$2190': '반왕의 부츠',
  '$2191': '반왕의 건틀릿',
  '$2192': '반왕의 투구',
  '$2194': '케레니스의 부츠',
  '$2195': '키메라의 가죽 (용)',
  '$2196': '키메라의 가죽 (산양)',
  '$2197': '키메라의 가죽 (사자)',
  '$2198': '키메라의 가죽 (뱀)',
  '$2199': '케레니스의 서클릿',
  '$2200': '용의 심장',
  '$2201': '케레니스의 장갑',
  '$2202': '케레니스의 로브',
  '$2203': '지도:아덴',
  '$2208': '마프르의 도끼',
  '$2212': '리치 로브',
  '$2213': '메두사 방패',
  '$2214': '미노타우르스 도끼',
  '$2215': '에이션트 자이언트의 반지',
  '$2221': '영혼의 결정체 조각',
  '$2222': '영혼의 편지',
  '$2223': '왕가의 문장 조각',
  '$2224': '신비한 주머니',
  '$2225': '수호자의 반지',
  '$2239': '도펠갱어의 체액',
  '$2240': '고대 열쇠의 조각 (머리 부분)',
  '$2241': '고대인의 지혜',
  '$2242': '고대의 악마에 대한 기록서',
  '$2243': '파란색 플룻',
  '$2244': '신비한 소라 껍데기',
  '$2245': '밤의 시야',
  '$2246': '고대의 유산',
  '$2247': '찢어진 조사원의 조사서',
  '$2248': '조사원의 조사서 조각',
  '$2249': '보호 장갑',
  '$2250': '마나 망토',
  '$2251': '용기의 벨트',
  '$2252': '고대인의 활',
  '$2253': '천상의 검',
  '$2264': '가디언의 주머니',
  '$2265': '마샤의 주머니',
  '$2268': '결혼반지 (사파이어)',
  '$2269': '결혼반지 (다이아몬드)',
  '$2270': '망령의 주머니',
  '$2292': '타라스의 마법 주머니',
  '$2293': '기사의 견습용 검',
  '$2346': '발록의 검',
  '$2347': '발록의 시선',
  '$2348': '발록의 발톱',
  '$2349': '발록의 심장',
  '$2350': '데스 블레이드',
  '$2351': '마나 수정구',
  '$2352': '화염의 활',
  '$2353': '화염의 검',
  '$2354': '황금 지휘봉',
  '$2363': '고대 군주의 열쇠',
  '$2364': '고대 기사의 열쇠',
  '$2365': '고대 요정의 열쇠',
  '$2366': '고대 마법사의 열쇠',
  '$2367': '운명의 열쇠',
  '$2373': '결혼반지 (에메랄드)',
  '$2374': '결혼반지 (루비)',
  '$2375': '결혼반지 (금)',
  '$2376': '결혼반지 (은)',
  '$2377': '고대인의 화살',
  '$2378': '고대 열쇠의 조각 (몸 부분)',
  '$2380': '혈맹 귀환 주문서',
  '$2404': '오만의 탑 31층 이동주문서',
  '$2405': '오만의 탑 41층 이동주문서',
  '$2406': '제니스의 반지',
  '$2408': '보물 상자',
  '$2410': '그림자 가면',
  '$2411': '오크 장로의 머리카락',
  '$2412': '그림자 장갑',
  '$2413': '비밀 명단',
  '$2414': '살생부 (글루딘 마을)',
  '$2415': '살생부 (화전민 마을)',
  '$2416': '살생부 (켄트 마을)',
  '$2417': '살생부 (우드벡 마을)',
  '$2418': '살생부 (하이네 마을)',
  '$2419': '살생부 (아덴 마을)',
  '$2420': '살생부 (기란 마을)',
  '$2421': '살생부 주머니',
  '$2422': '죽음의 서약',
  '$2423': '그림자 부츠',
  '$2424': '예티의 머리카락',
  '$2425': '펑거스의 독',
  '$2426': '어쌔신의 증표',
  '$2427': '부식된 어쌔신의 검',
  '$2428': '죽음을 주관 하는 자에 관한 문서',
  '$2429': '어쌔신 마스터의 상자',
  '$2455': '흑왕도',
  '$2456': '흑왕아',
  '$2457': '흑왕궁',
  '$2463': '스팅',
  '$2464': '건틀렛',
  '$2474': '흑마석',
  '$2475': '흑요석',
  '$2476': '강암석',
  '$2477': '현암석',
  '$2478': '암황석',
  '$2516': '실버 스팅',
  '$2517': '헤비 스팅',
  '$2518': '흑정령의 수정 (블라인드 하이딩)',
  '$2519': '흑정령의 수정 (인챈트 베놈)',
  '$2520': '흑정령의 수정 (쉐도우 아머)',
  '$2521': '흑정령의 수정 (브링 스톤)',
  '$2522': '흑정령의 수정 (무빙 악셀레이션)',
  '$2523': '흑정령의 수정 (버닝 스피릿츠)',
  '$2524': '흑정령의 수정 (다크 블라인드)',
  '$2525': '흑정령의 수정 (베놈 레지스트)',
  '$2526': '흑정령의 수정 (더블 브레이크)',
  '$2527': '흑정령의 수정 (언케니 닷지)',
  '$2528': '흑정령의 수정 (쉐도우 팽)',
  '$2529': '흑정령의 수정 (파이널 번)',
  '$2530': '엘릭서 (STR)',
  '$2531': '엘릭서 (CON)',
  '$2532': '엘릭서 (DEX)',
  '$2533': '엘릭서 (INT)',
  '$2534': '엘릭서 (WIS)',
  '$2535': '엘릭서 (CHA)',
  '$2536': '다크 엘프의 견습용 검',
  '$2537': '다크엘프의 견습용 투구',
  '$2538': '다크 엘프의 견습용 부츠',
  '$2539': '다크 엘프의 견습용 망토',
  '$2540': '칸의 주머니',
  '$2541': '론드의 주머니',
  '$2542': '블루디카의 주머니',
  '$2543': '지도:침묵의 동굴',
  '$2575': '고대의 체력 회복제',
  '$2576': '고대의 고급 체력 회복제',
  '$2577': '고대의 강력 체력 회복제',
  '$2578': '찹살떡',
  '$2579': '쑥송편',
  '$2580': '월병',
  '$2581': '복월병',
  '$2582': '봉인된 오만의 탑 11층 이동 부적',
  '$2583': '봉인된 오만의 탑 21층 이동 부적',
  '$2584': '봉인된 오만의 탑 31층 이동 부적',
  '$2585': '봉인된 오만의 탑 41층 이동 부적',
  '$2591': '그랑카인의 눈물',
  '$2592': '검은 혈흔',
  '$2593': '저주의피혁 (열화)',
  '$2594': '저주의피혁 (물결)',
  '$2595': '저주의피혁 (바람)',
  '$2596': '저주의피혁 (대지)',
  '$2600': '빛나는 비늘',
  '$2601': '빛나는 신체의 벨트',
  '$2602': '빛나는 정신의 벨트',
  '$2603': '빛나는 영혼의 벨트',
  '$2626': '진 건틀렛',
  '$2627': '피어스의 선물주머니',
  '$2648': '핑거 오브 데스',
  '$2649': '다크 스타',
  '$2651': '진실의 가면',
  '$2652': '타락의 열쇠',
  '$2653': '엔디아의 보자기',
  '$2654': '엔디아의 편지',
  '$2668': '봉인된 오만의 탑 51층 이동 부적',
  '$2669': '봉인된 오만의 탑 61층 이동 부적',
  '$2670': '봉인된 오만의 탑 71층 이동 부적',
  '$2671': '봉인된 오만의 탑 81층 이동 부적',
  '$2672': '봉인된 오만의 탑 91층 이동 부적',
  '$2673': '오만의 탑 51층 이동주문서',
  '$2674': '오만의 탑 61층 이동주문서',
  '$2675': '오만의 탑 71층 이동주문서',
  '$2676': '오만의 탑 81층 이동주문서',
  '$2677': '오만의 탑 91층 이동주문서',
  '$2683': '크리스마스 폭죽',
  '$2685': '녹색 양말',
  '$2687': '크리스마스 트리',
  '$2714': '아덴 기사단의 망토',
  '$2719': '2단계 마법주사위',
  '$2720': '3단계 마법주사위',
  '$2721': '4단계 마법주사위',
  '$2722': '6단계 마법주사위',
  '$2744': '흑장로의 로브',
  '$2745': '흑장로의 샌달',
  '$2746': '발터자르의 모자',
  '$2747': '카스파의 모자',
  '$2748': '메르키오르의 모자',
  '$2749': '세마의 모자',
  '$2750': '오림의 반지',
  '$2751': '세마의 반지',
  '$2752': '얼음 여왕의 매력적인 샌달',
  '$2753': '얼음 여왕의 매력적인 드레스',
  '$2754': '마력을 잃은 얼음 여왕의 지팡이',
  '$2755': '도펠겡어 보스의 왼쪽 반지',
  '$2756': '도펠겡어 보스의 오른쪽 반지',
  '$2757': '도펠겡어 보스의 목걸이',
  '$2758': '데스 나이트의 불검',
  '$2759': '론드의 이도류',
  '$2760': '알려지지 않은 창',
  '$2761': '알려지지 않은 도끼',
  '$2762': '복수의 칼날',
  '$2763': '증오의 발톱',
  '$2764': '마력을 잃은 데몬의 지팡이',
  '$2765': '바포메트의 갑옷',
  '$2766': '마력을 잃은 바포메트의 지팡이',
  '$2767': '베레스의 부츠',
  '$2768': '마력을 잃은 베레스의 지팡이',
  '$2769': '거대 여왕 개미의 금빛 날개',
  '$2770': '거대 여왕 개미의 은빛 날개',
  '$2771': '고대 요정의 활',
  '$2772': '고대 다크엘프의 검',
  '$2773': '커츠의 장갑',
  '$2774': '커츠의 갑옷',
  '$2775': '커츠의 부츠',
  '$2776': '커츠의 투구',
  '$2777': '검',
  '$2778': '안타라스의 비늘',
  '$2779': '안타라스의 부서진 발톱',
  '$2780': '안타라스의 시선',
  '$2781': '안타라스의 눈물',
  '$2782': '안타라스의 분신',
  '$2783': '안타라스의 숨결',
  '$2784': '안타라스의 뼈',
  '$2785': '안타라스의 이빨',
  '$2786': '발라카스의 비늘',
  '$2787': '발라카스의 부서진 발톱',
  '$2788': '발라카스의 시선',
  '$2789': '발라카스의 눈물',
  '$2790': '발라카스의 분신',
  '$2791': '발라카스의 숨결',
  '$2792': '발라카스의 뼈',
  '$2793': '발라카스의 이빨',
  '$2794': '파푸리온의 비늘',
  '$2795': '파푸리온의 부서진 발톱',
  '$2796': '파푸리온의 시선',
  '$2797': '파푸리온의 눈물',
  '$2798': '파푸리온의 분신',
  '$2799': '파푸리온의 숨결',
  '$2800': '파푸리온의 뼈',
  '$2801': '파푸리온의 이빨',
  '$2802': '린드비오르의 비늘',
  '$2803': '린드비오르의 부서진 발톱',
  '$2804': '린드비오르의 시선',
  '$2805': '린드비오르의 눈물',
  '$2806': '린드비오르의 분신',
  '$2807': '린드비오르의 숨결',
  '$2808': '린드비오르의 뼈',
  '$2809': '린드비오르의 이빨',
  '$2810': '진화의 열매',
  '$2858': '아이리스의 목걸이',
  '$2859': '나이트발드의 양손검',
  '$2862': '오만의 탑 100층 이동주문서',
  '$2864': '달빛의 눈물',
  '$2866': '사냥꾼 송곳니',
  '$2868': '파멸의 이빨',
  '$2869': '전투 송곳니',
  '$2871': '디바인 송곳니',
  '$2872': '황금의 이빨',
  '$2873': '강철의 이빨',
  '$2874': '빅토리 송곳니',
  '$2876': '체인 펫 아머',
  '$2877': '크로스 펫 아머',
  '$2878': '레더 펫 아머',
  '$2879': '미스릴 펫 아머',
  '$2881': '본 펫 아머',
  '$2882': '강철 펫 아머',
  '$2884': '혼돈의 열쇠',
  '$2903': '라스타바드 장검',
  '$2904': '라스타바드 이도류',
  '$2905': '라스타바드 단검',
  '$2906': '라스타바드 한손창',
  '$2907': '라스타바드 보우',
  '$2908': '라스타바드 헤비 크로스 보우',
  '$2909': '라스타바드 스태프',
  '$2910': '라스타바드 체인 메일',
  '$2911': '라스타바드 징박힌 레더 아머',
  '$2912': '라스타바드 로브',
  '$2913': '라스타바드 부츠',
  '$2914': '라스타바드 라운드 실드',
  '$2915': '라스타바드 크로스 보우',
  '$2916': '라스타바드 레더 아머',
  '$2917': '비스트테이머의 반지',
  '$2918': '늑대가죽 망토',
  '$2919': '엘리멘탈리스트의 반지',
  '$2920': '라스타바드 블레이드',
  '$2988': '마족의 주문서',
  '$2989': '영혼의 구',
  '$2990': '얼음 여왕의 지팡이',
  '$2991': '데몬의 지팡이',
  '$2992': '바포메트의 지팡이',
  '$2993': '베레스의 지팡이',
  '$3006': '다크엘프 병사의 배지',
  '$3007': '다크엘프 장군의 배지',
  '$3008': '수호 단원의 반지',
  '$3018': '보상금',
  '$3019': '블랙 미스릴 원석',
  '$3020': '블랙 미스릴',
  '$3021': '블랙 미스릴 판금',
  '$3022': '머미로드의 왕관',
  '$3025': '은쫑즈',
  '$3026': '금쫑즈',
  '$3027': '황금괴',
  '$3028': '황금원석조각',
  '$3029': '황금 판금',
  '$3031': '은원석조각',
  '$3032': '은 판금',
  '$3033': '백금괴',
  '$3034': '백금원석조각',
  '$3035': '백금 판금',
  '$3052': '카리프의 주머니',
  '$3056': '명예의 코인',
  '$3057': '신뢰의 코인',
  '$3058': '지혜의 코인',
  '$3059': '용기의 코인',
  '$3060': '골렘의 숨결',
  '$3061': '불새의 숨결',
  '$3062': '얼음여왕의 숨결',
  '$3063': '드레이크의 숨결',
  '$3064': '마프르의 유산',
  '$3065': '파아그리오의 유산',
  '$3066': '에바의 유산',
  '$3067': '사이하의 유산',
  '$3068': '뱀파이어의 망토',
  '$3069': '사신의 망토',
  '$3073': '바란카의 크로우',
  '$3074': '바란카의 갑옷',
  '$3075': '바란카의 투구',
  '$3076': '바란카의 장갑',
  '$3077': '바란카의 부츠',
  '$3078': '라이아의 완드',
  '$3079': '라이아의 목걸이',
  '$3080': '라이아의 반지',
  '$3081': '라이아의 로브',
  '$3082': '비스트 서머너의 반지',
  '$3083': '비스트 서머너의 목걸이',
  '$3084': '비스트 서머너의 로브',
  '$3085': '비스트 서머너의 채찍',
  '$3086': '블랙 위자드의 반지',
  '$3087': '블랙 위자드의 목걸이',
  '$3088': '블랙 위자드의 로브',
  '$3089': '블랙 위자드의 스태프',
  '$3090': '다크 포레스터의 반지',
  '$3091': '다크 포레스터의 부츠',
  '$3092': '다크 포레스터의 갑옷',
  '$3093': '다크 포레스터의 물약',
  '$3094': '재료',
  '$3095': '블랙 엔트의 껍질',
  '$3096': '블랙 엔트의 열매',
  '$3097': '죽음의 대가',
  '$3098': '블랙 티거의 가죽',
  '$3099': '블랙 티거의 송곳니',
  '$3100': '블랙 티거의 발톱',
  '$3101': '딥 플라워의 뿌리',
  '$3102': '딥 플라워의 꽃 봉오리',
  '$3103': '플레이트웜의 독주머니',
  '$3104': '플레이트웜의 송곳니',
  '$3105': '플레이트웜의 껍질',
  '$3106': '두더지의 가죽',
  '$3107': '딜로의 꼬리',
  '$3108': '플레이트웜 껍질 갑옷',
  '$3109': '블랙 티거 가죽 망토',
  '$3110': '침묵의 검',
  '$3111': '디아드요새 이도류',
  '$3112': '디아드요새 크로스보우',
  '$3113': '광물 수거 문서',
  '$3114': '광물 주머니',
  '$3115': '브롭의 위액',
  '$3116': '화산재',
  '$3117': '흑정령석',
  '$3150': '곡괭이',
  '$3151': '오움의 주머니',
  '$3152': '오움이 만들던 조각상',
  '$3153': '오움의 투박한 조각상',
  '$3154': '오움이 다듬던 조각상',
  '$3155': '오움의 섬세한 조각상',
  '$3156': '오움의 채색된 조각상',
  '$3157': '오움의 완성된 조각상',
  '$3158': '상자',
  '$3172': '흑정령의 수정 (드레스 마이티)',
  '$3173': '흑정령의 수정 (드레스 덱스터리티)',
  '$3174': '흑정령의 수정 (드레스 이베이젼)',
  '$3175': '마법서 (샤이닝 오라)',
  '$3176': '마법서 (브레이브 오라)',
  '$3184': '카리프의 고급 주머니',
  '$3185': '부활과 영생의 계약서',
  '$3186': '라보르의 주머니',
  '$3193': '조화의 인장',
  '$3194': '정신력의 인장',
  '$3195': '체력의 인장',
  '$3199': '라블라의 주머니',
  '$3205': '황금색 양말',
  '$3235': '계산기',
  '$3236': '얇은 판금',
  '$3240': '용기의 반지',
  '$3241': '자애의 목걸이',
  '$3247': '오리하루콘 단검',
  '$3248': '미스릴 단검',
  '$3249': '데몬 액스',
  '$3250': '크림슨 랜스',
  '$3251': '맘보 코트',
  '$3252': '맘보 모자',
  '$3253': '염령의 장갑',
  '$3254': '빙령의 장갑',
  '$3255': '풍령의 장갑',
  '$3256': '암령의 장갑',
  '$3257': '심연의 반지',
  '$3258': '봉인 주문서',
  '$3259': '기술서 (쇼크 스턴)',
  '$3260': '마법서 (런 클렌)',
  '$3261': '정령의 수정 (트리플 애로우)',
  '$3262': '정령의 수정 (엘리멘탈 폴다운)',
  '$3263': '정령의 수정 (카운터 미러)',
  '$3265': '정령의 수정 (엑조틱 바이탈라이즈)',
  '$3266': '정령의 수정 (워터 라이프)',
  '$3267': '정령의 수정 (엘리멘탈 파이어)',
  '$3268': '봉인 해제 주문서',
  '$3278': '말하는 두루마리',
  '$3279': '상아탑의 한손검',
  '$3280': '상아탑의 양손검',
  '$3281': '상아탑의 도끼',
  '$3282': '상아탑의 창',
  '$3283': '상아탑의 활',
  '$3284': '상아탑의 석궁',
  '$3285': '상아탑의 지팡이',
  '$3286': '상아탑의 이도류',
  '$3287': '상아탑의 크로우',
  '$3288': '상아탑의 단검',
  '$3289': '상아탑의 가죽 투구',
  '$3290': '상아탑의 가죽 갑옷',
  '$3291': '상아탑의 가죽 샌달',
  '$3292': '상아탑의 가죽 장갑',
  '$3293': '상아탑의 가죽 방패',
  '$3294': '상아탑의 반지',
  '$3295': '상아탑의 티셔츠',
  '$3296': '상아탑의 순간이동 주문서',
  '$3297': '상아탑의 귀환 주문서',
  '$3298': '상아탑의 확인 주문서',
  '$3299': '상아탑의 저주 풀기 주문서',
  '$3300': '상아탑의 변신 주문서',
  '$3301': '상아탑의 체력 회복제',
  '$3302': '상아탑의 속도향상 물약',
  '$3303': '말하는 섬 이동 주문서',
  '$3304': '글루딘 마을 귀환 주문서',
  '$3305': '켄트 마을 귀환 주문서',
  '$3306': '우드벡 마을 귀환 주문서',
  '$3307': '화전민 마을 귀환 주문서',
  '$3308': '요정숲 귀환 주문서',
  '$3309': '은기사 마을 귀환 주문서',
  '$3311': '하이네 마을 귀환 주문서',
  '$3312': '오렌 마을 귀환 주문서',
  '$3313': '웰던 마을 귀환 주문서',
  '$3314': '아덴 마을 귀환 주문서',
  '$3315': '침묵의 동굴 귀환 주문서',
  '$3334': '드루가 가문 1세대 가보',
  '$3335': '드루가 가문 2세대 가보',
  '$3336': '드루가 가문 3세대 가보',
  '$3337': '드루가 가문 4세대 가보',
  '$3338': '드루가 가문 5세대 가보',
  '$3339': '드루가 가문 6세대 가보',
  '$3340': '드루가 가문 7세대 가보',
  '$3341': '알 수 없는 가보',
  '$3342': '타락의 머리카락',
  '$3343': '타락의 로브',
  '$3344': '타락의 장갑',
  '$3345': '타락의 망토',
  '$3346': '타락의 부츠',
  '$3347': '타락의 낫',
  '$3348': '타락의 재물',
  '$3349': '타락의 악마서 1권',
  '$3350': '타락의 외침',
  '$3351': '타락의 악마서 2권',
  '$3352': '타락의 독',
  '$3353': '타락의 악마서 3권',
  '$3354': '타락의 이빨',
  '$3355': '타락의 악마서 4권',
  '$3356': '타락의 손길',
  '$3357': '고대인의 주술서 1권',
  '$3358': '악마의 검은색 족쇄',
  '$3359': '기안의 두루마리',
  '$3360': '칼바스의 두루마리',
  '$3361': '고대인의 주술서 2권',
  '$3362': '악마의 붉은색 족쇄',
  '$3363': '고대인의 연금술 두루마리',
  '$3364': '고대인의 주술서 3권',
  '$3365': '악마의 파란색 족쇄',
  '$3366': '고대인의 주술 두루마리',
  '$3367': '고대인의 주술서 4권',
  '$3368': '악마의 흰색 족쇄',
  '$3369': '연금술사의 돌',
  '$3370': '정신력의 물약',
  '$3371': '저주받은 피',
  '$3372': '악마의 피',
  '$3373': '발록의 핏빛 망토',
  '$3374': '악마의 크로스보우',
  '$3375': '악마의 칼',
  '$3376': '악마의 이도류',
  '$3377': '악마의 크로우',
  '$3390': '낡은 가죽주머니',
  '$3391': '낡은 비단주머니',
  '$3392': '유물주머니',
  '$3393': '켄트용사의 검',
  '$3394': '켄트궁사의 활',
  '$3395': '켄트마법사의 지팡이',
  '$3396': '켄트암살자의 이도류',
  '$3397': '켄트전사의 도끼',
  '$3398': '켄트문장 부츠',
  '$3399': '켄트문장 갑옷',
  '$3400': '켄트문장 장갑',
  '$3401': '켄트문장 방패',
  '$3402': '켄트문장 투구',
  '$3403': '그을린 빵조각',
  '$3404': '타다남은 빵조각',
  '$3405': '와인',
  '$3406': '위스키',
  '$3422': '로이의 주머니',
  '$3423': '북쪽 감옥 열쇠',
  '$3439': '해적섬행 배표',
  '$3440': '숨겨진 선착장행 배표',
  '$3447': '왕궁 요리사의 향신료',
  '$3450': '아르카의 마법 주머니',
  '$3482': '북동쪽 감옥 열쇠',
  '$3483': '동쪽 감옥 열쇠',
  '$3484': '보물지도 조각',
  '$3485': '아들의 편지',
  '$3486': '아들의 유골',
  '$3487': '완성된 보물지도',
  '$3488': '드레이크의 열쇠',
  '$3489': '푸른 도마뱀의 껍질',
  '$3490': '아들의 초상화',
  '$3491': '작은 보물지도',
  '$3492': '카드무스의 목걸이',
  '$3493': '무한의 화살통',
  '$3494': '기타 아이템',
  '$3495': '푸른 해적 두건',
  '$3496': '푸른 해적 장갑',
  '$3497': '푸른 해적 부츠',
  '$3498': '바다의 망토',
  '$3499': '푸른 해적 가죽갑옷',
  '$3500': '해골 목걸이',
  '$3501': '저주받은 루비 반지',
  '$3502': '저주받은 사파이어 반지',
  '$3503': '저주받은 다이아몬드 반지',
  '$3504': '커트라스',
  '$3505': '샴쉬르',
  '$3512': '황금 화살',
  '$3513': '오리하루콘 화살',
  '$3514': '블랙 미스릴 화살',
  '$3521': '정령의 결정',
  '$3522': '정령의 파편',
  '$3528': '저주받은 에메랄드 반지',
  '$3532': '박쥐 송곳니',
  '$3533': '늑대 가죽',
  '$3534': '딥플라워 줄기',
  '$3535': '블랙 티거의 심장',
  '$3536': '다크엘프 주머니',
  '$3537': '스콜피온 껍질',
  '$3538': '거대무리안 거미줄',
  '$3540': '딜로 발톱',
  '$3541': '켈베로스 털',
  '$3542': '대공동의 수정',
  '$3543': '정령 조각',
  '$3544': '대공동 주문서 조각',
  '$3546': '저항군 마을 귀환 주문서',
  '$3547': '은둔자 마을 귀환 주문서',
  '$3553': '디아드 주문서 조각',
  '$3554': '디아드 이동주문서',
  '$3568': '작은 주머니',
  '$3569': '할아버지의 보물',
  '$3588': '은제 플룻',
  '$3589': '친구의 가방',
  '$3598': '레스타의 반지',
  '$3607': '황금 전사의 투구',
  '$3608': '황금 전사의 갑옷',
  '$3609': '황금 전사의 장갑',
  '$3610': '황금 전사의 부츠',
  '$3611': '황금 전사의 방패',
  '$3612': '전설의 검',
  '$3616': '지도:해적섬',
  '$3623': '디 폰 더블릿 슈지츠',
  '$3627': '디 폰 더블릿 슈체츠',
  '$3631': '디 폰 더블릿 슈뷔츠',
  '$3671': '영양 만점 목걸이',
  '$3672': '영양 만점 반지',
  '$3673': '영양 만점 허리끈',
  '$3714': '토끼 반지',
  '$3724': '하이콜리 목걸이',
  '$3725': '하이라쿤 목걸이',
  '$3735': '천상의 망치',
  '$3736': '활',
  '$3737': '혼돈의 손톱',
  '$3738': '혼돈의 문장',
  '$3739': '혼돈의 손길',
  '$3740': '혼돈의 망토',
  '$3741': '혼돈의 투구',
  '$3742': '죽음의 갑옷',
  '$3743': '죽음의 비늘',
  '$3744': '죽음의 망토',
  '$3745': '죽음의 보호구 조각',
  '$3746': '야히의 투구',
  '$3747': '야히의 셔츠',
  '$3748': '야히의 갑옷',
  '$3749': '야히의 망토',
  '$3750': '야히의 부츠',
  '$3751': '야히의 장갑',
  '$3752': '야히의 반지',
  '$3753': '야히의 목걸이',
  '$3755': '춤추는 귀걸이',
  '$3756': '쌍둥이의 귀걸이',
  '$3757': '축제의 귀걸이',
  '$3758': '절정의 귀걸이',
  '$3759': '폭주의 귀걸이',
  '$3760': '환마의 귀걸이',
  '$3761': '일족의 귀걸이',
  '$3762': '노예의 귀걸이',
  '$3763': '혼돈의 머리카락',
  '$3764': '퀘스트 아이템',
  '$3765': '죽음의 망치',
  '$3766': '죽음의 도끼',
  '$3767': '죽음의 창',
  '$3768': '죽음의 칼',
  '$3769': '죽음의 의지',
  '$3770': '야히의 가면',
  '$3771': '야히의 갈비뼈',
  '$3772': '야히의 손톱',
  '$3773': '야히의 꼬리',
  '$3774': '야히의 날개',
  '$3775': '야히의 의지',
  '$3776': '영혼석 파편',
  '$3784': '오리하루콘 도금 뼈 화살',
  '$3786': '디에고의 낡은 다이어리',
  '$3787': '해어지고 구겨진 러브레터',
  '$3788': '리자드맨의 보고서',
  '$3789': '리자드맨의 보물',
  '$3790': '명예의 검',
  '$3791': '심연의 이도류',
  '$3792': '침묵의 크로스보우',
  '$3793': '칠흑의 수정구',
  '$3794': '신의의 방패',
  '$3795': '붉은 욕망의 검',
  '$3796': '리자드맨 용사의 검',
  '$3797': '리자드맨 영웅의 장갑',
  '$3834': '진명황의 집행검',
  '$3835': '바람칼날의 단검',
  '$3836': '붉은 그림자의 이도류',
  '$3837': '야수왕의 크로우',
  '$3838': '수정 결정체 지팡이',
  '$3839': '무관의 양손검',
  '$3840': '무관의 장검',
  '$3841': '무관의 갑옷',
  '$3842': '무관의 투구',
  '$3843': '무관의 망토',
  '$3844': '무관의 장갑',
  '$3845': '무관의 부츠',
  '$3846': '무관의 방패',
  '$3847': '신관의 지팡이',
  '$3848': '신관의 로브',
  '$3849': '신관의 투구',
  '$3850': '신관의 망토',
  '$3851': '신관의 장갑',
  '$3852': '신관의 부츠',
  '$3853': '신관의 마력서',
  '$3854': '명법군왕의 망토',
  '$3855': '마령군왕의 로브',
  '$3856': '마수군왕의 부츠',
  '$3857': '암살군왕의 장갑',
  '$3858': '명법군왕의 반지',
  '$3859': '마령군왕의 목걸이',
  '$3860': '암살군왕의 암살도',
  '$3861': '마수군왕의 크로우',
  '$3862': '어둠의 벨트',
  '$3863': '어둠의 칼날',
  '$3864': '피의 대검',
  '$3865': '붉은 수정의 지팡이',
  '$3866': '송곳날 이도류',
  '$3867': '수정 단검',
  '$3868': '불의 숨결',
  '$3869': '물의 숨결',
  '$3870': '바람의 숨결',
  '$3871': '대지의 숨결',
  '$3872': '어둠의 숨결',
  '$3873': '불타는 가죽',
  '$3874': '흑빛 날개',
  '$3875': '수정 송곳니',
  '$3876': '어둠의 광석',
  '$3877': '어둠의 주괴',
  '$3878': '정신지배의 돌',
  '$3879': '명법군의 징표함',
  '$3880': '명법군의 징표',
  '$3881': '마령군의 징표함',
  '$3882': '마령군의 징표',
  '$3883': '마수군의 징표함',
  '$3884': '마수군의 징표',
  '$3885': '암살군의 징표함',
  '$3886': '암살군의 징표',
  '$3945': '그림자 신전 2층 열쇠',
  '$3946': '퀘스트 아이템',
  '$3956': '혈석 파편',
  '$3969': '푸른 수정',
  '$3970': '녹색 수정',
  '$3971': '흰색 수정',
  '$3972': '붉은 수정',
  '$3973': '보라색 수정',
  '$3974': '큰 푸른 수정',
  '$3975': '큰 녹색 수정',
  '$3976': '큰 붉은 수정',
  '$3977': '정령의 눈물',
  '$3978': '원정대원의 유품',
  '$3979': '오염된 활',
  '$3980': '오염된 갑옷',
  '$3981': '오염된 장갑',
  '$3982': '오염된 투구',
  '$3983': '오염된 부츠',
  '$3984': '오염된 망토',
  '$3985': '오염된 엔트의 껍질',
  '$3986': '오염된 엔트의 줄기',
  '$3987': '오염된 엔트의 열매',
  '$3988': '아라스의 편지',
  '$3991': '원정대원의 활',
  '$3992': '원정대원의 장갑',
  '$3993': '원정대원의 갑옷',
  '$3994': '원정대원의 투구',
  '$3995': '원정대원의 부츠',
  '$3996': '원정대원의 망토',
  '$3997': '%i의 요정 활',
  '$3998': '%i의 요정 장갑',
  '$3999': '%i의 요정 갑옷',
  '$4000': '%i의 요정 투구',
  '$4001': '%i의 요정 부츠',
  '$4002': '%i의 요정 망토',
  '$4003': '마르바의 편지',
  '$4004': '아라스의 부적',
  '$4007': '기술서 (리덕션 아머)',
  '$4008': '기술서 (바운스 어택)',
  '$4009': '흑마법 가루',
  '$4020': '미로 구조도',
  '$4021': '두번째 미로 열쇠',
  '$4022': '세번째 미로 열쇠',
  '$4023': '시련의 검A',
  '$4024': '시련의 검B',
  '$4025': '시련의 검C',
  '$4026': '시련의 검D',
  '$4027': '시련의 주문서',
  '$4032': '용사의 귀걸이',
  '$4038': '영광의 목걸이',
  '$4039': '전사의 귀걸이',
  '$4040': '영웅의 귀걸이',
  '$4046': '시련의 검',
  '$4058': '마수군왕의 인장',
  '$4059': '마령군왕의 인장',
  '$4060': '암살군왕의 인장',
  '$4061': '명법군왕의 인장',
  '$4062': '영웅의 반지',
  '$4065': '붉은색 축구복',
  '$4066': '푸른색 축구복',
  '$4067': '미리티아 부츠',
  '$4068': '헤리오챠무',
  '$4092': '정화의 귀걸이',
  '$4093': '붉은 저주의 목걸이',
  '$4094': '푸른 저주의 목걸이',
  '$4095': '녹색 저주의 목걸이',
  '$4176': '은 쟁반',
  '$4177': '은 촛대',
  '$4178': '예언가의 진주',
  '$4181': '산적의 열쇠',
  '$4182': '산적의 봉투',
  '$4187': '오크의 징표',
  '$4188': '오크의 목걸이',
  '$4189': '주술 가루',
  '$4198': '환각의 가루',
  '$4288': '호출 피리',
  '$4323': '할로윈 축복 모자',
  '$4325': '라스타바드 보급품 상자',
  '$4338': '저주받은 단테스의 검',
  '$4341': '이리스의 목걸이',
  '$4342': '이리스의 반지',
  '$4343': '이리스의 가방',
  '$4344': '다크엘프 영혼의 결정체',
  '$4345': '로빈후드의 반지',
  '$4348': '달빛의 정기',
  '$4349': '신성한 유니콘의 뿔',
  '$4350': '달의 장궁',
  '$4351': '에바의 단검',
  '$4352': '라스타바드 보급품 자루',
  '$4353': '이리스의 명령서：영혼의 안식',
  '$4354': '재료',
  '$4357': '사엘의 반지',
  '$4358': '신성한 에바의 물',
  '$4362': '오크의 보물 자루',
  '$4363': '바베큐',
  '$4375': '기르타스의 검',
  '$4376': '기르타스의 지팡이',
  '$4377': '진명황의 장갑',
  '$4378': '진명황의 갑옷',
  '$4379': '진명황의 부츠',
  '$4380': '진명황의 투구',
  '$4381': '진명황의 망토',
  '$4384': '연옥의 크로우',
  '$4385': '해신의 삼지창',
  '$4386': '위엄의 상징',
  '$4387': '진홍의 크로스보우',
  '$4388': '선명의 머리띠',
  '$4389': '고통의 목걸이',
  '$4390': '고뇌의 목걸이',
  '$4392': '증오의 비늘',
  '$4393': '항해 일지 1 페이지',
  '$4394': '항해 일지 2 페이지',
  '$4395': '항해 일지 3 페이지',
  '$4396': '항해 일지 4 페이지',
  '$4397': '항해 일지 5 페이지',
  '$4398': '항해 일지 6 페이지',
  '$4399': '항해 일지 7 페이지',
  '$4400': '항해 일지 8 페이지',
  '$4401': '항해 일지 9 페이지',
  '$4402': '항해 일지 10 페이지',
  '$4403': '퀘스트 아이템',
  '$4404': '완성한 항해 일지',
  '$4405': '풀',
  '$4406': '풀이 발려진 항해일지 1장',
  '$4407': '풀이 발려진 항해일지 2장',
  '$4408': '풀이 발려진 항해일지 3장',
  '$4409': '풀이 발려진 항해일지 4장',
  '$4410': '풀이 발려진 항해일지 5장',
  '$4411': '풀이 발려진 항해일지 6장',
  '$4412': '풀이 발려진 항해일지 7장',
  '$4413': '풀이 발려진 항해일지 8장',
  '$4414': '풀이 발려진 항해일지 9장',
  '$4415': '풀이 발려진 항해일지 10장',
  '$4416': '발록의 가면',
  '$4417': '발록의 날개',
  '$4418': '발록의 손톱',
  '$4419': '발록의 분신',
  '$4420': '발록의 전율',
  '$4421': '발록의 의지',
  '$4422': '발록의 이빨',
  '$4423': '양손검',
  '$4424': '발록의 뿔',
  '$4425': '시버인의 꼬리 : 공기',
  '$4426': '시버인의 꼬리 : 물',
  '$4427': '시버인의 꼬리 : 불',
  '$4428': '시버인의 꼬리 : 흙',
  '$4429': '시버인의 창',
  '$4430': '시버인의 방패',
  '$4431': '시버인의 앞니',
  '$4432': '시버인의 가죽 : 공기',
  '$4433': '시버인의 가죽 : 물',
  '$4434': '시버인의 가죽 : 불',
  '$4435': '시버인의 가죽 : 흙',
  '$4436': '모래',
  '$4437': '피묻은 모래',
  '$4438': '파사즈의 날개',
  '$4439': '파사즈의 숨결',
  '$4440': '앙가스의 꼬리',
  '$4441': '앙가스의 이빨',
  '$4442': '앙가스의 철퇴',
  '$4443': '디고의 피',
  '$4444': '디고의 지느러미',
  '$4445': '노예의 목걸이',
  '$4446': '약속의 목걸이',
  '$4447': '해방의 목걸이',
  '$4448': '사냥개의 목걸이',
  '$4449': '마족의 목걸이',
  '$4450': '용사의 목걸이',
  '$4451': '장군의 목걸이',
  '$4452': '대장군의 목걸이',
  '$4455': '항해사의 주머니',
  '$4456': '귀걸이',
  '$4457': '지혜의 귀걸이',
  '$4458': '진실의 귀걸이',
  '$4459': '지배의 귀걸이',
  '$4460': '분노의 귀걸이',
  '$4461': '용맹의 귀걸이',
  '$4462': '불사의 귀걸이',
  '$4463': '열정의 귀걸이',
  '$4464': '명예의 귀걸이',
  '$4469': '이리스의 추천서',
  '$4470': '이리스의 명령서：동맹의 의지',
  '$4474': '어둠의 비늘',
  '$4475': '열화의 비늘',
  '$4476': '배덕의 비늘',
  '$4478': '정화의 물약',
  '$4479': '검은 귀걸이',
  '$4482': '신비한 물약:1단계',
  '$4483': '신비한 물약:2단계',
  '$4484': '신비한 물약:3단계',
  '$4485': '신비한 물약:4단계',
  '$4502': '신비한 검은 귀걸이',
  '$4503': '신비한 마법사의 귀걸이',
  '$4504': '신비한 회색 마법사의 귀걸이',
  '$4505': '신비한 백색 마법사의 귀걸이',
  '$4506': '관용의 귀걸이',
  '$4507': '신비한 투사의 귀걸이',
  '$4508': '신비한 회색 투사의 귀걸이',
  '$4509': '신비한 백색 투사의 귀걸이',
  '$4511': '신비한 기사의 귀걸이',
  '$4512': '신비한 회색 기사의 귀걸이',
  '$4513': '신비한 백색 기사의 귀걸이',
  '$4514': '마법사의 귀걸이',
  '$4515': '회색 마법사의 귀걸이',
  '$4516': '백색 마법사의 귀걸이',
  '$4517': '투사의 귀걸이',
  '$4518': '회색 투사의 귀걸이',
  '$4519': '백색 투사의 귀걸이',
  '$4520': '기사의 귀걸이',
  '$4521': '회색 기사의 귀걸이',
  '$4522': '백색 기사의 귀걸이',
  '$4523': '가공된 루비:1단계',
  '$4524': '가공된 루비:2단계',
  '$4525': '가공된 루비:3단계',
  '$4526': '가공된 루비:4단계',
  '$4527': '가공된 사파이어:1단계',
  '$4528': '가공된 사파이어:2단계',
  '$4529': '가공된 사파이어:3단계',
  '$4530': '가공된 사파이어:4단계',
  '$4531': '가공된 에메랄드:1단계',
  '$4532': '가공된 에메랄드:2단계',
  '$4533': '가공된 에메랄드:3단계',
  '$4534': '가공된 에메랄드:4단계',
  '$4535': '가공된 화령의 다이아몬드:1단계',
  '$4536': '가공된 화령의 다이아몬드:2단계',
  '$4537': '가공된 화령의 다이아몬드:3단계',
  '$4538': '가공된 화령의 다이아몬드:4단계',
  '$4539': '남작의 화령 반지',
  '$4540': '백작의 화령 반지',
  '$4541': '공작의 화령 반지',
  '$4542': '군왕의 화령 반지',
  '$4543': '세공된 영웅의 화령 반지',
  '$4544': '세공된 남작의 화령 반지',
  '$4545': '세공된 백작의 화령 반지',
  '$4546': '세공된 공작의 화령 반지',
  '$4547': '남작의 수령 반지',
  '$4548': '백작의 수령 반지',
  '$4549': '공작의 수령 반지',
  '$4550': '군왕의 수령 반지',
  '$4551': '세공된 영웅의 수령 반지',
  '$4552': '세공된 남작의 수령 반지',
  '$4553': '세공된 백작의 수령 반지',
  '$4554': '세공된 공작의 수령 반지',
  '$4555': '남작의 지령 반지',
  '$4556': '백작의 지령 반지',
  '$4557': '공작의 지령 반지',
  '$4558': '군왕의 지령 반지',
  '$4559': '세공된 영웅의 지령 반지',
  '$4560': '세공된 남작의 지령 반지',
  '$4561': '세공된 백작의 지령 반지',
  '$4562': '세공된 공작의 지령 반지',
  '$4563': '남작의 풍령 반지',
  '$4564': '백작의 풍령 반지',
  '$4565': '공작의 풍령 반지',
  '$4566': '군왕의 풍령 반지',
  '$4567': '세공된 영웅의 풍령 반지',
  '$4568': '세공된 남작의 풍령 반지',
  '$4569': '세공된 백작의 풍령 반지',
  '$4570': '세공된 공작의 풍령 반지',
  '$4575': '데스나이트의 서',
  '$4576': '완성된 라스타바드의 역사서',
  '$4579': '가공된 수령의 다이아몬드:1단계',
  '$4580': '가공된 수령의 다이아몬드:2단계',
  '$4581': '가공된 수령의 다이아몬드:3단계',
  '$4582': '가공된 수령의 다이아몬드:4단계',
  '$4583': '가공된 지령의 다이아몬드:1단계',
  '$4584': '가공된 지령의 다이아몬드:2단계',
  '$4585': '가공된 지령의 다이아몬드:3단계',
  '$4586': '가공된 지령의 다이아몬드:4단계',
  '$4587': '가공된 풍령의 다이아몬드:1단계',
  '$4588': '가공된 풍령의 다이아몬드:2단계',
  '$4589': '가공된 풍령의 다이아몬드:3단계',
  '$4590': '가공된 풍령의 다이아몬드:4단계',
  '$4600': '봉인된 역사서 1장',
  '$4601': '봉인된 역사서 2장',
  '$4602': '봉인된 역사서 3장',
  '$4603': '봉인된 역사서 4장',
  '$4604': '봉인된 역사서 5장',
  '$4605': '봉인된 역사서 6장',
  '$4606': '봉인된 역사서 7장',
  '$4607': '봉인된 역사서 8장',
  '$4611': '라스타바드의 역사서 1장',
  '$4612': '라스타바드의 역사서 2장',
  '$4613': '라스타바드 무기제작 비법서',
  '$4616': '소환구 조각',
  '$4617': '소환구 핵',
  '$4618': '소환구：1 단계',
  '$4619': '소환구：2 단계',
  '$4620': '소환구：3 단계',
  '$4621': '소환구：4 단계',
  '$4622': '단테스의 소환구',
  '$4623': '럭키 캣 스카프',
  '$4624': '블랙 미스릴 용액',
  '$4627': '진명황의 방어구 비법서',
  '$4628': '물의 인장',
  '$4629': '불의 인장',
  '$4630': '공기의 인장',
  '$4631': '흙의 인장',
  '$4632': '물의 통행증',
  '$4633': '불의 통행증',
  '$4634': '공기의 통행증',
  '$4635': '흙의 통행증',
  '$4636': '물의 지배자',
  '$4637': '불의 지배자',
  '$4638': '공기의 지배자',
  '$4639': '흙의 지배자',
  '$4640': '원소의 지배자',
  '$4643': '성지의 유물',
  '$4644': '수행자의 경전',
  '$4657': '노나메의 추천서',
  '$4658': '조사단의 증서：조사단장 아투바 노아',
  '$4659': '조사단의 증서：요정 지역 두다마라 카메',
  '$4660': '조사단의 증서：인간 지역 네루가 바쿠모',
  '$4661': '조사단의 증서：정령 지역 두다마라 부카',
  '$4662': '조사단의 증서：오크 지역 네루가 후우모',
  '$4665': '오염된 줄기',
  '$4667': '오염된 허물',
  '$4669': '오염된 갈기털',
  '$4670': '오염된 뿌리',
  '$4672': '오염된 바람의 핵',
  '$4674': '오염된 물의 핵',
  '$4676': '오염된 불의 핵',
  '$4678': '오염된 대지의 핵',
  '$4680': '오염된 정령의 핵',
  '$4684': '오염된 요정의 날개',
  '$4685': '오염된 머리카락',
  '$4687': '스피리드의 뿌리',
  '$4688': '스피리드의 껍질',
  '$4689': '스피리드의 나뭇잎',
  '$4690': '스피리드의 나뭇가지',
  '$4695': '라스타바드의 역사서 3장',
  '$4696': '라스타바드의 역사서 4장',
  '$4697': '라스타바드의 역사서 5장',
  '$4698': '라스타바드의 역사서 6장',
  '$4699': '라스타바드의 역사서 7장',
  '$4700': '라스타바드의 역사서 8장',
  '$4712': '기술서 (솔리드 캐리지)',
  '$4713': '기술서 (카운터 배리어)',
  '$4714': '정령의 수정 (소울 오브 프레임)',
  '$4715': '정령의 수정 (어디셔널 파이어)',
  '$4716': '정령의 수정 (아쿠아 프로텍트)',
  '$4717': '정령의 수정 (폴루트 워터)',
  '$4718': '정령의 수정 (스트라이커 게일)',
  '$4750': '닭꼬치구이',
  '$4824': '고대의 금화',
  '$4826': '꿈꾸는 곰인형',
  '$4827': '유혹의 향수',
  '$4828': '사랑스러운 드레스',
  '$4829': '화려한 반지',
  '$4830': '상자',
  '$4831': '마이의 초상화',
  '$4832': '타로스의 루비',
  '$4833': '타로스의 에메랄드',
  '$4834': '타로스의 사파이어',
  '$4835': '타로스의 다이아몬드',
  '$4836': '볼품없는 고대 목걸이',
  '$4837': '복원된 고대 목걸이',
  '$4838': '빛나는 고대의 목걸이',
  '$4839': '쥬얼리 파우더',
  '$4842': '영웅의 위인전',
  '$4843': '세련된 모자',
  '$4844': '최고급 와인',
  '$4845': '알 수 없는 열쇠',
  '$4846': '에셈의 마음',
  '$4847': '에셈의 초상화',
  '$4852': '유품 자루',
  '$4853': '낡은 유품자루',
  '$4854': '오래된 유품자루',
  '$4855': '빛바랜 반지',
  '$4856': '피묻은 손수건',
  '$4857': '피묻은 문서',
  '$4858': '빛바랜 목걸이',
  '$4859': '아리아의 보답',
  '$4860': '피묻은 단검',
  '$4861': '검은 열쇠',
  '$4862': '마야의 지팡이',
  '$4864': '마야의 수정구슬',
  '$4874': '마이노 샤먼의 꼬리털',
  '$4875': '마이노의 꼬리털',
  '$4876': '바위 덩어리',
  '$4877': '다이아몬드 원석',
  '$4878': '화산암',
  '$4879': '철 광석',
  '$4880': '갑옷 조각',
  '$4913': '강화 용기의 물약',
  '$4916': '모듬 양념 소스',
  '$4918': '꿀',
  '$4919': '밀가루',
  '$4920': '치즈',
  '$4921': '토마토',
  '$4922': '장작',
  '$4923': '요리책 : 1단계',
  '$4924': '요리책 : 2단계',
  '$4925': '요리책 : 3단계',
  '$4929': '씨호떡',
  '$4930': '과일샐러드',
  '$4931': '과일 탕수육',
  '$4932': '괴물눈 스테이크',
  '$4933': '뻥튀기',
  '$4934': '옥수수구이',
  '$4935': '오뎅',
  '$4936': '와플',
  '$4938': '주먹밥',
  '$4940': '사그러지는 영혼',
  '$4941': '선원의 유해',
  '$4945': '하이 베어의 초커',
  '$4946': '붉은 오크의 마스크',
  '$4949': '격려의 물약',
  '$4950': '재능의 물약',
  '$4951': '후로라의 물약',
  '$4962': '행복의 작은 망치',
  '$4963': '빛의 부적',
  '$4969': '해바라기씨',
  '$4980': '기사의 혼',
  '$4981': '요정의 혼',
  '$4982': '군주의 혼',
  '$4983': '다크엘프의 혼',
  '$4984': '법사의 혼',
  '$4985': '날이 빠진 무기',
  '$5017': '로빈후드의 소개장',
  '$5018': '로빈후드의 메모지',
  '$5019': '축복받은 포도주',
  '$5020': '축복받은 보리빵',
  '$5021': '훈련 기사의 망토',
  '$5022': '포이즌 서펜트의 망토',
  '$5023': '파푸리온의 혈흔',
  '$5024': '망자의 쪽지',
  '$5025': '물의 정수',
  '$5026': '산성 유액',
  '$5027': '메두사의 피',
  '$5028': '제론의 교본',
  '$5097': '국화꽃다발',
  '$5098': '데이지의 꽃다발',
  '$5099': '장미의 꽃다발',
  '$5100': '칼라의 꽃다발',
  '$5101': '해바라기의 꽃다발',
  '$5102': '후리지아의 꽃다발',
  '$5103': '성수',
  '$5104': '용사의 증표',
  '$5105': '고우스트의 숨결',
  '$5106': '조각 피자',
  '$5115': '신성한 미스릴 가루',
  '$5116': '픽시의 깃털',
  '$5117': '창천의 검',
  '$5118': '창천의 대검',
  '$5119': '창천의 도끼',
  '$5120': '창천의 활',
  '$5121': '창천의 창',
  '$5122': '창천의 단검',
  '$5123': '창천의 이도류',
  '$5124': '창천의 크로우',
  '$5125': '창천의 지팡이',
  '$5126': '창천의 건틀렛',
  '$5127': '신비한 힐링포션',
  '$5128': '신비한 마나포션',
  '$5129': '라버본 헤드 변신물약',
  '$5130': '캥거루 먹이',
  '$5131': '판다곰 먹이',
  '$5132': '드레이크 선장 변신 터번',
  '$5133': '라버본 솔져 변신물약',
  '$5134': '라버본 나이프 변신물약',
  '$5135': '서큐버스퀸 변신 터번',
  '$5136': '나이트발드 변신 터번',
  '$5137': '아이리스 변신 터번',
  '$5143': '에브롤의 주머니',
  '$5145': '카헬의 타락한 가루',
  '$5146': '카헬의 무력한 가루',
  '$5147': '카헬의 아집의 가루',
  '$5148': '혈흔의 타락한 정수',
  '$5149': '혈흔의 무력한 정수',
  '$5150': '혈흔의 아집의 정수',
  '$5151': '혈흔의 타락한 가루',
  '$5152': '혈흔의 무력한 가루',
  '$5153': '혈흔의 아집의 가루',
  '$5154': '카헬의 타락한 정수',
  '$5155': '카헬의 무력한 정수',
  '$5156': '카헬의 아집의 정수',
  '$5157': '카헬의 정수',
  '$5158': '혈흔의 정수',
  '$5159': '용병단장 티온의 소개장',
  '$5160': '카헬의 지령서',
  '$5161': '혈흔의 지령서',
  '$5163': '기마용 투구',
  '$5171': '거대 병정 개미 박제',
  '$5172': '곰 박제',
  '$5173': '라미아 박제',
  '$5174': '블랙티거 박제',
  '$5175': '사슴 박제',
  '$5176': '청동기사',
  '$5177': '청동말',
  '$5178': '촛대',
  '$5179': '티테이불',
  '$5180': '하피 박제',
  '$5181': '화로',
  '$5182': '횃불',
  '$5183': '군주용 단상',
  '$5184': '깃발',
  '$5185': '티테이블 의자',
  '$5186': '파티션',
  '$5188': '카헬의 계약서',
  '$5189': '혈흔의 계약서',
  '$5192': '박제 제작 의뢰서',
  '$5193': '개미 사냥 증표',
  '$5194': '곰 사냥 증표',
  '$5195': '라미아 사냥 증표',
  '$5196': '블랙티거 사냥 증표',
  '$5197': '사슴 사냥 증표',
  '$5198': '하피 사냥 증표',
  '$5204': '점성술사의 항아리',
  '$5205': '점성술사의 구슬',
  '$5206': '점성술사의 부적',
  '$5211': '라르손의 추천서',
  '$5212': '쿠엔의 쪽지',
  '$5214': '파룸의 작물 주머니',
  '$5215': '파룸의 자원 리스트',
  '$5218': '곰고기 구이',
  '$5219': '개미다리 치즈구이',
  '$5220': '멧돼지 꼬치 구이',
  '$5221': '버섯 스프',
  '$5225': '마법인형 : 늑대인간',
  '$5226': '마법인형 : 버그베어',
  '$5227': '마법인형 : 서큐버스',
  '$5229': '붉은 오크의 마스크',
  '$5230': '붉은 오크의 귀걸이',
  '$5233': '쿠작의 식량',
  '$5234': '쿠작의 영약',
  '$5235': '해골 성배',
  '$5239': '용해제',
  '$5240': '결정체',
  '$5241': '개미다리',
  '$5242': '곰 고기',
  '$5243': '멧돼지 고기',
  '$5246': '마법 낚싯대',
  '$5248': '진귀한 거북이',
  '$5249': '붕어',
  '$5250': '잉어',
  '$5254': '할로윈 호박 장검',
  '$5255': '할로윈 호박 갑옷',
  '$5256': '어린 물고기',
  '$5257': '재빠른 물고기',
  '$5258': '강한 물고기',
  '$5259': '붉은 빛 나는 물고기',
  '$5260': '초록 빛 나는 물고기',
  '$5261': '파란 빛 나는 물고기',
  '$5262': '흰 빛 나는 물고기',
  '$5263': '깨진 반지',
  '$5264': '깨진 귀걸이',
  '$5265': '깨진 목걸이',
  '$5266': '수리된 반지',
  '$5267': '수리된 귀걸이',
  '$5268': '수리된 목걸이',
  '$5269': '물에 젖은 투구',
  '$5270': '물에 젖은 망토',
  '$5271': '물에 젖은 갑옷',
  '$5272': '물에 젖은 장갑',
  '$5273': '물에 젖은 부츠',
  '$5274': '물에 젖은 방패',
  '$5287': '용기있는 자의 호박 주머니',
  '$5304': '하멜의 숨결',
  '$5305': '펫매치 황금메달',
  '$5306': '승리의 인장',
  '$5307': '승자의 열매',
  '$5308': '깜짝 상자',
  '$5356': '캐릭터명의 힘의 티셔츠',
  '$5357': '캐릭터명의 민첩의 티셔츠',
  '$5358': '캐릭터명의 매력의 티셔츠',
  '$5359': '캐릭터명의 마력의 티셔츠',
  '$5360': '캐릭터명의 체력의 티셔츠',
  '$5361': '캐릭터명의 마나의 티셔츠',
  '$5362': '%i의 마법 저항의 T 셔츠',
  '$5368': 'A 알파벳 폭죽',
  '$5369': 'B 알파벳 폭죽',
  '$5370': 'C 알파벳 폭죽',
  '$5371': 'D 알파벳 폭죽',
  '$5372': 'E 알파벳 폭죽',
  '$5373': 'F 알파벳 폭죽',
  '$5374': 'G 알파벳 폭죽',
  '$5375': 'H 알파벳 폭죽',
  '$5376': 'I 알파벳 폭죽',
  '$5377': 'J 알파벳 폭죽',
  '$5378': 'K 알파벳 폭죽',
  '$5379': 'L 알파벳 폭죽',
  '$5380': 'M 알파벳 폭죽',
  '$5381': 'N 알파벳 폭죽',
  '$5382': 'O 알파벳 폭죽',
  '$5383': 'P 알파벳 폭죽',
  '$5384': 'Q 알파벳 폭죽',
  '$5385': 'R 알파벳 폭죽',
  '$5386': 'S 알파벳 폭죽',
  '$5387': 'T 알파벳 폭죽',
  '$5388': 'U 알파벳 폭죽',
  '$5389': 'V 알파벳 폭죽',
  '$5390': 'W 알파벳 폭죽',
  '$5391': 'X 알파벳 폭죽',
  '$5392': 'Y 알파벳 폭죽',
  '$5393': 'Z 알파벳 폭죽',
  '$5417': '마법 인형 : 엘더',
  '$5418': '마법 인형 : 크러스트 시안',
  '$5419': '마법 인형 : 스톤 골렘',
  '$5430': '캐비어 카나페',
  '$5431': '악어 스테이크',
  '$5432': '터틀드래곤 과자',
  '$5433': '키위 패롯 구이',
  '$5434': '스콜피온 구이',
  '$5435': '일렉카둠 스튜',
  '$5436': '거미다리 꼬치 구이',
  '$5437': '크랩살 스프',
  '$5438': '상어 알',
  '$5439': '악어 고기',
  '$5440': '키위 패롯 고기',
  '$5441': '스콜피온 살',
  '$5442': '일렉카둠 살',
  '$5443': '거미 다리 살',
  '$5444': '크랩살',
  '$5446': '터틀드래곤의 알',
  '$5448': '용자의 표식',
  '$5470': '펫매치 선물상자',
  '$5471': '데몬 동상',
  '$5472': '드레이크 동상',
  '$5473': '쿠거 동상',
  '$5474': '아이리스 동상',
  '$5475': '그레이트 미노타우르스 동상',
  '$5476': '케이크',
  '$5477': '분수',
  '$5478': '화병',
  '$5479': '꽃기둥',
  '$5480': '데몬의 영혼',
  '$5481': '드레이크의 영혼',
  '$5482': '쿠거의 영혼',
  '$5483': '아이리스의 영혼',
  '$5484': '그레이트 미노타우르스의 영혼',
  '$5486': '마나 마력의 단검',
  '$5487': '광풍의 도끼',
  '$5488': '파멸',
  '$5490': '프리 징 랜서',
  '$5491': '뇌 신검',
  '$5509': '생크림 케이크',
  '$5510': '초콜릿 케이크',
  '$5511': '치즈 케이크',
  '$5512': '녹차 롤 케이크',
  '$5518': '마법의 케이크 상자',
  '$5523': '빛을 잃은 영혼',
  '$5542': '아이스 데몬의 주머니',
  '$5543': '얼음 여왕의 주머니',
  '$5544': '얼음 여왕의 상자',
  '$5545': '얼음 여왕의 귀걸이',
  '$5546': '얼음 결정체',
  '$5547': '얼음성 열쇠',
  '$5548': '신생의 벨트',
  '$5549': '신생의 벨트',
  '$5550': '신생 목걸이',
  '$5555': '데스 매치 기념품 상자',
  '$5573': '운명의 귀걸이',
  '$5574': '명사수의 귀걸이',
  '$5575': '검투사의 귀걸이',
  '$5576': '대 마법사의 귀걸이',
  '$5579': '이동 명령서',
  '$5580': '단테스의 칙서',
  '$5581': '정령의 속삭임',
  '$5582': '고대 다크 엘프의 비법 서',
  '$5583': '밀봉 된 첩보 보고서',
  '$5584': '첩보보고 문서',
  '$5585': '성소 2 층 열쇠',
  '$5586': '성소 3 층 열쇠',
  '$5587': '마의 뿔피리',
  '$5588': '파괴의 비약',
  '$5589': '희망의 촛불',
  '$5616': '오염 된 오크의 숨결',
  '$5617': '더러운 정령의 핵',
  '$5618': '시루레인의 첫 번째 편지',
  '$5619': '시루레인의 두 번째 편지',
  '$5620': '시루레인의 세 번째 편지',
  '$5621': '시루레인의 네 번째 편지',
  '$5622': '시루레인의 다섯 번째 편지',
  '$5623': '시루레인 부대',
  '$5624': '요정 숲 순간 이동 주문서',
  '$5625': '상아탑 마을 이동 주문서',
  '$5626': '우드 벡 마을 이동 주문서',
  '$5627': '웰던 마을 이동 주문서',
  '$5628': '녹슨 피리',
  '$5629': '좀비 엘모어 마샬의 숨결',
  '$5630': '솔 샤이 카의 영혼석',
  '$5631': '켄라우헬의 골든 스틱',
  '$5632': '솔 샤이 카의 영혼의 피리',
  '$5633': '봉인 된 솔 샤이 카의 유품',
  '$5634': '엘모어 부대 일지',
  '$5635': '때 그린 크리스탈',
  '$5636': '때 블루 크리스탈',
  '$5637': '첫 번째 기억의 조각',
  '$5638': '첫 번째 사념의 조각',
  '$5639': '미완성 때 수정 구슬',
  '$5640': '시간의 수정 구슬',
  '$5641': '시간의 균열 사념 조각',
  '$5642': '시간의 균열 파편',
  '$5643': '오튜의 눈물',
  '$5644': '와이번의 눈물',
  '$5645': '시루레인 부적',
  '$5646': '특별한 원석',
  '$5648': '푸른 불꽃의 파편',
  '$5649': '사비우스의 사념 조각',
  '$5659': '환 술사의 망토',
  '$5660': '환 술사의 마법서',
  '$5661': '환 술사 전투 스틱',
  '$5662': '사파이어 키 링크',
  '$5663': '흑요석 키 링크',
  '$5664': '용 기사의 양손 검',
  '$5665': '용 기사의 망토',
  '$5666': '드래곤 스케일 가더',
  '$5667': '크리스탈 가더',
  '$5668': '소멸자의 체인 소드',
  '$5669': '파멸 자의 체인 소드',
  '$5670': '오크 밀사의 배지',
  '$5671': '동맹 기장',
  '$5672': '프로 켈의 첫 번째 지령서',
  '$5673': '프로 켈의 두 번째 지령서',
  '$5674': '프로 켈의 세 번째 지령서',
  '$5675': '프로 켈의 네 번째 지령서',
  '$5676': '오크 밀사의 피리',
  '$5677': '오크 밀사의 리더 메모',
  '$5678': '에티의 숨결',
  '$5679': '시루레인의 지령서',
  '$5681': '기억의 수정 (미러 이미지)',
  '$5682': '기억의 수정 (컨 퓨전)',
  '$5683': '기억의 수정 (스 토마스 에너지)',
  '$5684': '기억의 수정 (일루션 [오우거])',
  '$5685': '기억의 수정 (큐브 [점화])',
  '$5686': '기억의 수정 (컨센트 레이션)',
  '$5687': '기억의 수정 (마인드 브레이크)',
  '$5688': '기억의 수정 (본 브레이크)',
  '$5689': '기억의 수정 (일루션 서식])',
  '$5690': '기억의 수정 (큐브 [퀘이크])',
  '$5691': '기억의 수정 (페이션스)',
  '$5692': '기억의 수정 (판타즘)',
  '$5693': '기억의 수정 (아이즈 브레이크)',
  '$5694': '기억의 수정 (일루션 [다이아 골렘])',
  '$5695': '기억의 수정 (큐브 [충격])',
  '$5696': '기억의 수정 (인사이트)',
  '$5697': '기억의 수정 (패닉)',
  '$5698': '기억의 수정 (조이 오브 페인)',
  '$5699': '기억의 수정 (일루션 아바타])',
  '$5700': '기억의 수정 (큐브 [밸런스])',
  '$5701': '용 기사의 서판 (버닝 슬래쉬)',
  '$5702': '용 기사의 서판 (가드 브레이크)',
  '$5703': '용 기사의 서판 (마그마 브레스)',
  '$5704': '용 기사의 서판 (각성 [안타라스])',
  '$5705': '용 기사의 서판 (블러드 러스트)',
  '$5706': '용 기사의 서판 (포스 레이어)',
  '$5707': '용 기사의 서판 (피어)',
  '$5708': '용 기사의 서판 (마그마 애로우)',
  '$5709': '용 기사의 서판 (각성 파 푸리 온)',
  '$5710': '용 기사의 서판 (모탈 바디)',
  '$5711': '용 기사의 서판 (썬더 그랩)',
  '$5712': '용 기사의 서판 (호러 오브 데스)',
  '$5713': '용 기사의 서판 (아이 오브 드래곤)',
  '$5714': '용 기사의 서판 (각성 [발라카스])',
  '$5715': '균열의 핵',
  '$5716': '하급 오시리스의 보물 상자 조각 : 상',
  '$5717': '하급 오시리스의 보물 상자 조각 : 하',
  '$5718': '테베 오시리스의 이도류',
  '$5719': '테베 오시리스 양손 검',
  '$5720': '테베 오시리스의 활',
  '$5721': '테베 오시리스 직원',
  '$5722': '테베 오시리스의 벨트',
  '$5723': '테베 호루스의 반지',
  '$5724': '테베 아누비스의 반지',
  '$5725': '바람의 무기 강화 주문서',
  '$5726': '땅의 무기 강화 주문서',
  '$5727': '물의 무기 마법 주문서',
  '$5728': '불의 무기 마법 주문서',
  '$5729': '장식품 주문서',
  '$5730': '오크 수색 문서 (오크 숲)',
  '$5731': '프로 켈의 광물 주머니',
  '$5732': '오크 밀사 변신 주문서',
  '$5733': '루시우스의 사념 조각',
  '$5734': '프로 켈의 부적',
  '$5735': '소멸의 의지',
  '$5736': '프로 켈의 첫 번째 노트',
  '$5737': '프로 켈의 다섯 번째 지령서',
  '$5738': '붉은 불꽃의 파편',
  '$5739': '시루레인의 여섯 번째 편지',
  '$5740': '프로 켈의 편지',
  '$5741': '감시의 눈',
  '$5771': '두 번째 기억의 조각',
  '$5772': '세 번째 기억의 조각',
  '$5773': '두 번째 사념의 조각',
  '$5774': '세 번째 사념의 조각',
  '$5775': '시루레인의 추천서',
  '$5778': '용 기사의 서판 (드래곤 스킨)',
  '$5779': '오크 수색 문서 (글루딘)',
  '$5780': '오크 수색 문서 (윈 다우드)',
  '$5781': '이계의 사념 가루',
  '$5782': '타워 포털 주문서',
  '$5786': '용기의 결정',
  '$5799': '제단의 파편',
  '$5826': '마법 인형 :시 댄서',
  '$5828': '엘모어 단검',
  '$5829': '엘모어 검',
  '$5830': '엘모어 양손 검',
  '$5831': '엘모어 보우건',
  '$5832': '엘모어 크로우',
  '$5833': '엘모어 직원',
  '$5837': '증발 보호 스크롤',
  '$5840': '기타 아이템',
  '$5878': '샤르 나의 변신 주문서 (레벨 30)',
  '$5879': '샤르 나의 변신 주문서 (레벨 40)',
  '$5880': '샤르 나의 변신 주문서 (레벨 52)',
  '$5881': '샤르 나의 변신 주문서 (레벨 55)',
  '$5882': '샤르 나의 변신 주문서 (레벨 60)',
  '$5883': '샤르 나의 변신 주문서 (레벨 65)',
  '$5884': '샤르 나의 변신 주문서 (레벨 70)',
  '$5887': '타리온 무기 재료 목록',
  '$5893': '초보 비법서',
  '$5894': '쿠 카스의 증거',
  '$5895': '프로 켈의 두 번째 주',
  '$5900': '커츠의 비밀',
  '$5908': '닫힌 하급 오시리스의 보물 상자',
  '$5909': '열린 하급 오시리스의 보물 상자',
  '$5955': '상급 오시리스의 보물 상자 조각 : 상',
  '$5956': '상급 오시리스의 보물 상자 조각 : 하',
  '$5959': '수련의 증표',
  '$5964': '빛나는 실버',
  '$5965': '닫힌 상급 오시리스의 보물 상자',
  '$5966': '열린 상급 오시리스의 보물 상자',
  '$6072': '각인의 뼈 조각',
  '$6073': '유그 드라 열매',
  '$6074': '스타이 저의 간​​증',
  '$6075': '수련 비법서',
  '$6076': '도시락 보자기',
  '$6093': '테베 오시리스 제단 열쇠',
  '$6094': '고대 명궁의 가더',
  '$6095': '고대 투사의 가더',
  '$6099': '크러스트 시안의 하사 미소',
  '$6100': '그리폰 구이',
  '$6101': '코카 트리스 스테이크',
  '$6102': '터틀 드래곤 구이',
  '$6103': '레서 드래곤의 닭 날개',
  '$6104': '드레이크 구이',
  '$6105': '심해어 스튜',
  '$6106': '바실리스크 알 스프',
  '$6107': '크러스트 시안의 가위',
  '$6108': '그리폰 고기',
  '$6109': '코카 트리스 꼬리',
  '$6110': '터틀 드래곤 고기',
  '$6111': '레서 드래곤 날개',
  '$6112': '드레이크 고기',
  '$6113': '심해어의 몸',
  '$6114': '바실리스크의 알',
  '$6346': '속성석',
  '$6347': '고대의 옥새',
  '$6348': '영혼의 불꽃재',
  '$6405': '엘모어 체인 소드',
  '$6406': '엘모어 키 링크',
  '$6409': '상아탑의 귀걸이',
  '$6428': '쿠 쿨칸 스피어',
  '$6429': '쿠 쿨칸 건틀렛',
  '$6430': '쿠 쿨칸의 방패',
  '$6431': '쿠 쿨칸의 마스크',
  '$6432': '제브 레퀴의 송곳니',
  '$6433': '제브 레퀴의 마안',
  '$6454': '망토',
  '$6455': '바람의 망토',
  '$6456': '망토',
  '$6457': '망토',
  '$6519': '데스 나이트 변신 주문서',
  '$6520': '다크 엘프 변신 주문서',
  '$6521': '기도의 문양',
  '$6522': '기도의 문양 II',
  '$6523': '완력의 문양',
  '$6524': '민첩의 문양',
  '$6525': '지력의 문양',
  '$6526': '체력의 문양',
  '$6527': '정신의 문양',
  '$6528': '매력의 문양',
  '$6529': '방어의 문양',
  '$6530': '내화의 문양',
  '$6531': '내지의 문양',
  '$6532': '내수의 문양',
  '$6533': '풍속의 문양',
  '$6534': '생명의 문양',
  '$6535': '마법의 문양',
  '$6536': '치유의 물약',
  '$6537': '명상의 물약',
  '$6538': '생명의 물약',
  '$6539': '마법의 물약',
  '$6540': '완력의 물약',
  '$6541': '민첩의 물약',
  '$6542': '체력 물약',
  '$6543': '지력의 물약',
  '$6544': '정신의 물약',
  '$6545': '마법 저항 물약',
  '$6546': '분노의 물약',
  '$6547': '집중의 물약',
  '$6570': '오만의 탑 6층 이동 주문서',
  '$6580': '완력의 문양 II',
  '$6581': '민첩의 문양 II',
  '$6582': '지력의 문양 II',
  '$6583': '체력의 문양 II',
  '$6584': '정신의 문양 II',
  '$6585': '매력의 문양 II',
  '$6586': '방어의 문양 II',
  '$6587': '내화의 문양 II',
  '$6588': '내지의 문양 II',
  '$6589': '내수의 문양 II',
  '$6590': '풍속의 문양 II',
  '$6591': '생명의 문양 II',
  '$6592': '마법의 문양 II',
  '$6593': '검사의 문양',
  '$6594': '술사의 문양',
  '$6595': '기도의 물약',
  '$6596': '검사의 물약',
  '$6597': '술사의 물약',
  '$6611': '창고지기의 열쇠',
  '$6619': '순수한기도의 문양 [30일]',
  '$6620': '순수한기도의 문양 II [30일]',
  '$7376': '%i의 핑크 크리스탈 반지',
  '$7377': '%i 블루 크리스탈 반지',
  '$7378': '%i의 레드 크리스탈 반지',
  '$7379': '%i 그린 크리스탈 반지',
  '$7380': '%i 옐로우 크리스탈 반지',
  '$7381': '%i의 화이트 크리스탈 반지',
  '$7400': '마법 인형 : 스파 토이',
  '$7449': '마법 인형 : 라미아',
  '$7451': '산적의 보물 상자 열쇠',
  '$7453': '데스 매치 승리의 조각',
  '$7454': '유령의 집 승리의 조각',
  '$7455': '애완 레이스 승리의 조각',
  '$7456': '펫 매치 승리의 조각',
  '$7457': '무한 대전 승리의 조각',
  '$7490': '드루가 가방',
  '$7491': '드래곤 키',
  '$7500': '마법 인형 :로드',
  '$7501': '마법 인형 : 나이트',
  '$7502': '마법 인형 : 엘프',
  '$7503': '마법 인형 : 마법사',
  '$7504': '마법 인형 : 다크 엘프',
  '$7505': '마법 인형 : 용 기사',
  '$7506': '마법 인형 : 환 술사',
  '$7507': '젖은 모자',
  '$7508': '젖은 후드',
  '$7509': '박스 피쉬',
  '$7511': '마법 인형 : 코카 트리스',
  '$7512': '마법 인형 : 에티',
  '$7723': '마을 귀환 주문서 : 말하는 섬',
  '$7724': '마을 귀환 주문서 : 글루딘',
  '$7725': '마을 귀환 주문서 : 켄트',
  '$7726': '마을 귀환 주문서 : 우드 벡',
  '$7727': '마을 귀환 주문서 : 화전민 마을',
  '$7728': '마을 귀환 주문서 : 은기사 마을',
  '$7729': '마을 귀환 주문서 : 기란',
  '$7730': '마을 귀환 주문서 : 하이네',
  '$7731': '마을 귀환 주문서 : 오렌',
  '$7732': '마을 귀환 주문서 : 웰던',
  '$7733': '마을의 속도 향상 물약',
  '$7734': '마을의 호흡 물약',
  '$7735': '마을의 집중 물약',
  '$7736': '마을의 용기의 물약',
  '$7737': '마을의 마력 물약',
  '$7738': '마을의 지혜의 물약',
  '$7739': '마을의 변신 물약',
  '$7762': '탄생의 마안',
  '$7763': '형상의 마안',
  '$7764': '생명의 마안',
  '$7778': '코마 쿰의 숨결',
  '$7779': '그린 해츨링 알',
  '$7780': '옐로우 해츨링 알',
  '$7800': '응축 한 화합물',
  '$7865': '안타라스 그랜드 판금 갑옷',
  '$7866': '안타라스 그랜드 로브',
  '$7867': '안타라스 그랜드 가죽 조끼',
  '$7868': '안타라스 그랜드 비늘 갑옷',
  '$7869': '파 푸리 온 하이드로 판금 갑옷',
  '$7870': '파 푸리 온 하이드로 로브',
  '$7871': '파 푸리 온 하이드로 가죽 조끼',
  '$7872': '파 푸리 온 하이드로 비늘 갑옷',
  '$7873': '린드 비 오르 스톰 판금 갑옷',
  '$7874': '린드 비 오르 스톰 로브',
  '$7875': '린드 비 오르 스톰 가죽 조끼',
  '$7876': '린드 비 오르 스톰 비늘 갑옷',
  '$7877': '발라카스 화염 갑옷',
  '$7878': '발라카스 화염 로브',
  '$7879': '발라카스 화염의 가죽 조끼',
  '$7880': '발라카스 화염 비늘 갑옷',
  '$7881': '난쟁이 버섯',
  '$7882': '난쟁이 부적',
  '$7883': '오래된 물 진주',
  '$7884': '오래된 화이트 크리스탈',
  '$7885': '지룡의 마안',
  '$7886': '수룡의 마안',
  '$7887': '풍룡의 마안',
  '$7888': '화룡의 마안',
  '$7921': '사성',
  '$7922': '오성',
  '$7923': '육성',
  '$7924': '칠성',
  '$7936': '마리스 엘리먼트 소드',
  '$7937': '마리스 엘리먼트 보우',
  '$7938': '마리스 엘리먼트 스태프',
  '$7939': '마리스 엘리먼트 크로우',
  '$7940': '마리스 엘리먼트 체인 소드',
  '$7941': '마리스 엘리먼트 키 링크',
  '$7943': '시공의 항아리',
  '$7949': '지룡의 메마른 눈물',
  '$7950': '화룡의 메마른 눈물',
  '$7951': '수룡의 메마른 눈물',
  '$7952': '풍룡의 메마른 눈물',
  '$8377': '%i의 스턴 내성의 T 셔츠',
  '$8378': '%i의 홀드 내성의 T 셔츠',
  '$8410': '마법 인형 : 아주르 해츨링',
  '$8411': '마법 인형 : 크림슨 해츨링',
  '$8412': '신비한 프리즘 : 진화 한 남성 해츨링',
  '$8413': '신비한 프리즘 : 진화 한 여성 해츨링',
  '$8426': '상아탑의 마법 주머니',
  '$8427': '상아탑의 보급품 전송 주문서',
  '$8428': '상아탑의 묘약',
  '$8429': '여행자의 무기 마법 주문서',
  '$8430': '여행자의 방어구 마법 주문서',
  '$8499': '바다의 비밀',
  '$8508': '싱싱한 미끼',
  '$8527': '루돌프 마법 모자',
  '$8544': '상아탑의 망토',
  '$8586': '상아탑의 화살',
  '$8643': '10 주년 기념 회복 반지',
  '$8644': '10 주년 기념 중앙 링',
  '$8645': '10 주년 기념 체력 반지',
  '$8646': '10 주년 기념 마나린구',
  '$8647': '10 주년 기념 마법 저항 반지',
  '$8750': '신생 귀걸이',
  '$8811': '짧고 가벼운 낚싯대',
  '$8824': '숨겨 지은 마족의 소드',
  '$8825': '숨겨 지은 마족의 보우',
  '$8826': '숨겨 지은 마족의 스태프',
  '$8827': '숨겨진 마족의 크로우',
  '$8828': '숨겨진 마족의 체인 소드',
  '$8829': '숨겨진 마족의 키 링크',
  '$8831': '11월 10일',
  '$8832': '6월 2일',
  '$8833': '8 월 9 일',
  '$8834': '10월 12일',
  '$8835': '2월 24일',
  '$8836': '2월 25일',
  '$8837': '5월 5일',
  '$8838': '1월 1일',
  '$8839': '6 월 9 일',
  '$8840': '8월 19일',
  '$8841': '하딘의 일기장',
  '$8843': '시공의 구슬',
  '$8859': '토끼 투구',
  '$8860': '토끼 투구',
  '$8919': '군주의 봉투',
  '$8920': '나이트의 봉투',
  '$8921': '에르프의 봉투',
  '$8922': '위저드의 봉투',
  '$8981': '블랙 윙 케레니스 변신 주문서',
  '$8982': '리틀 케레니스 변신 주문서',
  '$9031': '셔츠',
  '$9032': '역전의 장갑',
  '$9033': '역전의 부츠',
  '$9034': '역전의 망토',
  '$9048': '역전의 석궁',
  '$9051': '정령의 신발 : 체력',
  '$9052': '정령의 신발 : 마력',
  '$9057': '편력의 가더',
  '$9058': '피어 팬더 머플러',
  '$9061': '신생 링',
  '$9064': '할로윈 장검',
  '$9065': '할로윈 아모',
  '$9066': '궁극 할로윈 검',
  '$9067': '얼티메이트 할로윈 아모',
  '$9069': '하이 폭스의 초커',
  '$9070': '하이 래빗의 초커',
  '$9075': '과자 바구니',
  '$9076': '맛있는 사탕',
  '$9080': '상아탑의기도의 문양',
  '$9081': '상아탑의 완력의 문양',
  '$9082': '상아탑의 민첩의 문양',
  '$9083': '상아탑의 지력의 문양',
  '$9084': '상아탑의 체력의 문양',
  '$9085': '상아탑의 정신의 문양',
  '$9086': '상아탑의 매력의 문양',
  '$9087': '상아탑의 방어의 문양',
  '$9088': '상아탑의 생활의 문양',
  '$9089': '상아탑의 마법의 문양',
  '$9102': '호반 상자',
  '$9408': '호노오노 부적',
  '$9409': '호노오노 외투',
  '$9410': '코오리노 외투',
  '$9450': '난쟁이 포도 주스',
  '$9451': '난쟁이 포도 추출물',
  '$9452': '모포 상자 : 추출 300 개',
  '$9453': '모포의 계약서 : 주스 100 개',
  '$9454': '모포의 계약서 : 주스 200 개',
  '$9455': '모포 상자 : 주스 100 개',
  '$9456': '모포 상자 : 주스 200 개',
  '$9457': '모포 상자 : 주스 300 개',
  '$9458': '모포 상자 : 추출 100 개',
  '$9459': '모포 상자 : 추출 200 개',
  '$9460': '미친 시계 : 2 시간',
  '$9461': '미친 시계 : 4 시간',
  '$9479': '%i의 치유의 T 셔츠',
  '$9480': '%i 명상의 T 셔츠',
  '$9487': '배송원 미믹 피리 : 주스 100 개',
  '$9488': '배송원 미믹 피리 : 주스 200 개',
  '$9493': '모포의 계약서 : 주스 300 개',
  '$9494': '모포의 계약서 : 추출물 100 개',
  '$9495': '모포의 계약서 : 추출물 200 개',
  '$9496': '모포의 계약서 : 추출물 300 개',
  '$9497': '배송원 미믹 피리 : 주스 300 개',
  '$9498': '배송원 미믹 피리 : 추출물 100 개',
  '$9499': '배송원 미믹 피리 : 추출물 200 개',
  '$9500': '배송원 미믹 피리 : 추출물 300 개',
  '$9590': '마법 인형 : 허수아비',
  '$9621': '지룡의 증거',
  '$9622': '수룡의 증거',
  '$9623': '풍룡의 증거',
  '$9624': '화룡의 증거',
  '$9625': '달아난 드래곤의 흔적',
  '$9626': '용의 눈물',
  '$9627': '드래곤의 돌',
  '$9628': '진돗개의 먹이',
  '$9629': '타이거의 먹이',
  '$9688': '키루톤 계약',
  '$9689': '메린의 계약서',
  '$9690': '진돗개 주머니',
  '$9691': '타이거 번식지',
  '$9692': '배송 원 미믹 피리 : 진돗개 바구니',
  '$9693': '배송 원 미믹 피리 : 호랑이 사육장',
  '$9694': '창천의 기사 변신 주문서',
  '$9766': '특별한 진돗개의 먹이',
  '$9767': '특별한 타이거의 먹이',
  '$9848': '마녀의 모자',
  '$9849': '검은 고양이 모자',
  '$9925': '상아탑의 탈리스만',
  '$10085': '용아의 벨트',
  '$10129': '마법 인형 : 눈싸움 요정',
  '$10139': '마법 인형 : 눈사람',
  '$10140': '드래곤의 메달',
  '$10174': '기모노',
  '$10175': '유카타',
  '$10600': '주술의 부대',
  '$10601': '올 딘 가방',
  '$10602': '오림의 일기장',
  '$10604': '젖은 하딘 상자',
  '$10616': '오림의 일기 6 월 14 일',
  '$10617': '오림의 일기 6 월 16 일',
  '$10618': '오림의 일기 6 월 18 일',
  '$10619': '오림의 일기 6 월 21 일',
  '$10620': '오림의 일기 6 월 22 일',
  '$10621': '오림의 일기 6 월 25 일',
  '$10622': '오림의 일기 7 월 5 일',
  '$10623': '오림의 일기 7 월 17 일',
  '$10624': '오림의 일기 7 월 18 일',
  '$10625': '오림의 일기 8 월 5 일',
  '$10626': '오림의 일기 8 월 8 일',
  '$10627': '오림의 일기 8 월 9 일',
  '$10628': '오림의 일기 8 월 10 일',
  '$10629': '오림의 일기 8 월 11 일',
  '$10630': '오림의 일기 8 월 12 일',
  '$10631': '오림의 일기 8 월 13 일',
  '$10632': '오림의 일기 8 월 14 일',
  '$10633': '오림의 일기 8 월 15 일',
  '$10688': '1 단계 보상 상자',
  '$10689': '2 단계 보상 상자',
  '$10690': '3 단계 보상 상자',
  '$10691': '4 단계 보상 상자',
  '$10692': '5 단계 보상 상자',
  '$10693': '6 단계 보상 상자',
  '$10694': '7 단계 보상 상자',
  '$10695': '8 단계 보상 상자',
  '$10696': '9 단계 보상 상자',
  '$10697': '10 단계 보상 상자',
  '$10698': '11 단계 보상 상자',
  '$10699': '12 단계 보상 상자',
  '$10700': '13 단계 보상 상자',
  '$10701': '14 단계 보상 상자',
  '$10702': '15 단계 보상 상자',
  '$10703': '16 단계 보상 상자',
  '$10704': '체력의 가더',
  '$10705': '마나의 가더',
  '$10706': '마법사의 가더',
  '$10738': '9 주년 애니버서리 검',
  '$10739': '9 주년 애니버서리 직원',
  '$10740': '9 주년 애니버서리 체인 소드',
  '$10741': '9 주년 애니버서리 크로우',
  '$10742': '9 주년 애니버서리 열쇠 고리',
  '$10743': '9 주년 애니버서리 보우',
  '$10763': '오림의 망토',
  '$10764': '젤라틴 큐브 목걸이 : 검사',
  '$10765': '젤라틴 큐브 목걸이 : 술사',
  '$11452': '마법 인형',
  '$11453': '마법 인형',
  '$11454': '마법 인형',
  '$11455': '마법 인형',
  '$11456': '신비의 버섯 파우더',
  '$11457': '슬픔의 눈물',
  '$11458': '수액',
  '$11459': '마법 약의 재료',
  '$11460': '진실 티백',
  '$11461': '제프 계약',
  '$11462': '제프의​마법 약',
  '$11463': '짐승의 선물',
  '$11464': '1시간 매직 차지',
  '$11465': '5시간의 매직 차지',
  '$11466': '10시간의 매직 차지',
  '$11467': '25시간의 매직 차지',
  '$11508': '악한 활력',
  '$11509': '타 라스 부츠',
  '$11510': '타 라스 장갑',
  '$11535': '영수증',
  '$11816': '코오리노 장갑',
  '$11817': '효오가노 장갑',
  '$11818': '토우도노 장갑',
  '$11819': '후부키노 장갑',
  '$12250': '할로윈 호박 장갑 2012',
  '$12333': '오만의 탑 1층 이동 주문서',
  '$12334': '기타 아이템',
  '$12335': '봉인 된 오만의 탑 1층 이동 부적',
  '$12347': '혼돈의 오만의 탑 1층 이동 부적',
  '$12348': '혼돈의 오만의 탑 11층 이동 부적',
  '$12349': '혼돈의 오만의 탑 21층 이동 부적',
  '$12350': '혼돈의 오만의 탑 31층 이동 부적',
  '$12351': '혼돈의 오만의 탑 41층 이동 부적',
  '$12352': '혼돈의 오만의 탑 51층 이동 부적',
  '$12353': '혼돈의 오만의 탑 61층 이동 부적',
  '$12354': '혼돈의 오만의 탑 71층 이동 부적',
  '$12355': '혼돈의 오만의 탑 81층 이동 부적',
  '$12356': '혼돈의 오만의 탑 91층 이동 부적',
  '$12357': '변이 된 오만의 탑 1층 이동 부적',
  '$12358': '변이 된 오만의 탑 11층 이동 부적',
  '$12359': '변이 된 오만의 탑 21층 이동 부적',
  '$12360': '변이 된 오만의 탑 31층 이동 부적',
  '$12361': '변이 된 오만의 탑 41층 이동 부적',
  '$12362': '변이 된 오만의 탑 51층 이동 부적',
  '$12363': '변이 된 오만의 탑 61층 이동 부적',
  '$12364': '변이 된 오만의 탑 71층 이동 부적',
  '$12365': '변이 된 오만의 탑 81층 이동 부적',
  '$12366': '변이 된 오만의 탑 91층 이동 부적',
  '$12423': '시어의 심안',
  '$12562': '10 주년 양손 검',
  '$12563': '10 주년 스피어',
  '$12564': '10 주년 보우',
  '$12565': '10 주년 직원',
  '$12566': '10 주년 이도류',
  '$12787': '방어 용아 링',
  '$12788': '체력의 용아 링',
  '$12789': '마력의 용아의 반지',
  '$12790': '방어 용아 반지 (땅)',
  '$12791': '방어 용아 반지 (바람)',
  '$12793': '고대의 용사의 영혼 Ⅰ',
  '$12794': '고대의 용사의 영혼 Ⅱ',
  '$12805': '방어 용아 반지 (불)',
  '$12806': '방어 용아 반지 (물)',
  '$12807': '체력의 용아 반지 (땅)',
  '$12808': '체력의 용아 반지 (바람)',
  '$12809': '체력의 용아 반지 (불)',
  '$12810': '체력의 용아 반지 (물)',
  '$12811': '마력의 용아의 반지 (땅)',
  '$12812': '마력의 용아의 반지 (바람)',
  '$12813': '마력의 용아의 반지 (불)',
  '$12814': '마력의 용아의 반지 (물)',
  '$12855': '마법 인형 : 드레이크',
  '$12892': '극한의 갑옷',
  '$12893': '극한의 투구',
  '$12894': '극한의 부츠',
  '$12901': '극한의 체인 소드',
  '$12902': '한랭의 키 링크',
  '$12903': '얼음 여왕의 매력적인 티아라',
  '$12955': '극한의 티아라 원석',
  '$12956': '극한의 샌달 원석',
  '$12957': '극한의 드레스 옷감',
  '$13012': '10주년 기념 반지 전용 강화 주문서',
  '$13160': '글로리 어스 케이드 실드',
  '$13161': '글로리 어스 케이드 가더',
  '$13164': 'Lv52 사무라이 변신 주문서',
  '$13165': 'Lv57 사무라이 변신 주문서',
  '$13166': 'Lv62 사무라이 변신 주문서',
  '$13167': 'Lv52 공주 무사 변신 주문서',
  '$13168': 'Lv57 공주 무사 변신 주문서',
  '$13169': 'Lv62 공주 무사 변신 주문서',
  '$13170': 'Lv52 영주 변신 주문서',
  '$13171': 'Lv57 영주 변신 주문서',
  '$13172': 'Lv62 영주 변신 주문서',
  '$13173': 'Lv52 음양사 변신 주문서',
  '$13174': 'Lv57 음양사 변신 주문서',
  '$13175': 'Lv62 음양사 변신 주문서',
  '$13176': 'Lv52 닌자 변신 주문서',
  '$13177': 'Lv57 닌자 변신 주문서',
  '$13178': 'Lv62 닌자 변신 주문서',
  '$13179': '상자',
  '$13348': '촉매 추출 가방',
  '$13551': '공포의 뱀파이어 망토',
  '$13776': '왕가의 귀걸이',
  '$13777': '왕가의 강한 목걸이',
  '$13778': '왕가의 현명 목걸이',
  '$13779': '왕가의 용맹 목걸이',
  '$13780': '파괴의 장궁',
  '$13781': '할 파스의 집념',
  '$13819': '천사의 지팡이',
  '$13906': '力強い和牛ステーキ',
  '$13907': '素早い鮭の煮付',
  '$13908': '賢い七面鳥焼き',
  '$13909': '修練の鶏スープ',
  '$13922': '腕力のお弁当かご',
  '$13923': '機敏のお弁当かご',
  '$13924': '知力のお弁当かご',
  '$13925': '成長のお弁当かご',
  '$13935': '闇精霊の水晶(アーマー ブレイク)',
  '$14100': '호박 랜턴',
  '$14376': '전사의 힘 허리띠',
  '$14377': '수험의 힘 허리띠',
  '$14378': '꿈의 춤 허리띠',
  '$14379': '뜨거운 용사의 영혼',
  '$14380': '뜨거운 용사의 땀 피',
  '$14384': '행운의 도끼',
  '$14394': '할로윈 호박 갑옷 2012',
  '$14442': '봉인 된 요괴의 영혼',
  '$14443': '소 악마의 독',
  '$14717': '주문서',
};
